/* tslint:disable */
/* eslint-disable */
/**
 * Marco Email Parser API
 * Marco Email Parser API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  Account,
  ActiveStatusChallengeResponse,
  AdjustCreditError,
  AdjustCreditRequest,
  ApplePayMerchantSession,
  ApplePayMerchantSessionRequest,
  ApplePayNotConfiguredError,
  ApplePayTokenizedPayload,
  ApplyBookingCreditsRequest,
  AutoSaveTriggerRequest,
  AwardWalletAuthUrlRequest,
  AwardWalletAuthUrlResponse,
  AwardWalletConnectionInfoResponse,
  AwardWalletSyncResponse,
  BetterRoomsResponse,
  CanSendEmailRequest,
  CanSendEmailResponse,
  CreateFlightCreditRequest,
  CreateFreeNightCreditRequest,
  CreateSearchPresetRequest,
  CreateUpdateLoyaltyAccountRequest,
  CreateUpgradeCertificateRequest,
  Email,
  EmailPromotionsResponse,
  ExecutiveAssistantInvitationRequest,
  ExecutiveAssistantInvitationResponse,
  FlightCredit,
  FlightCreditsResponse,
  FlightReservation,
  FreeNightCredit,
  FreeNightCreditsResponse,
  GondolaMappedResponse,
  HTTPBadRequestError,
  HTTPUnauthorizedError,
  HTTPValidationError,
  Hotel,
  HotelStayRequest,
  HotelStays,
  InviteLinkRequest,
  Itineraries,
  LoyaltyAccount,
  LoyaltyAccountsResponse,
  ManageGmailRequest,
  ManageGmailResponse,
  ManualMxRewardCreateRequest,
  MemberStayRequest,
  MemberStayResponse,
  MxConnectWidgetUrlRequest,
  MxConnectWidgetUrlResponse,
  MxReward,
  MxRewardUpdateRequest,
  MxRewards,
  MxSyncRequest,
  NotFoundError,
  PaymentMethod,
  PaymentMethodPutRequest,
  ProductAnnouncements,
  RatePastStayRequest,
  RateRefreshRequest,
  RateRefreshResponse,
  RateUpdateRequest,
  RateUpdateResponse,
  RecomputeBookingCreditsRequest,
  RecordEmailSentRequest,
  RecordHotelRateUpdateSavingsRequest,
  RecordHotelRateUpdateSavingsResponse,
  Referral,
  ReferralPreview,
  ReferralsRequest,
  SearchPreset,
  SearchPresetsResponse,
  ServerError,
  StatusChallengeRequest,
  StatusChallengeResponse,
  StatusMatchResponse,
  StripeCheckoutSessionRequest,
  StripeCheckoutSessionResponse,
  SubscriptionRequest,
  SuccessResponse,
  TravelHistoryResponse,
  TravelProfile,
  TravelProfileResponse,
  Trip,
  TripForwardingRelationshipPutRequest,
  TripForwardingRelationshipRequest,
  TripForwardingRelationshipResponse,
  Trips,
  UpdateFlightCreditRequest,
  UpdateFreeNightCreditRequest,
  UpdateUpgradeCertificateRequest,
  UpgradeCertificate,
  UpgradeCertificatesResponse,
  User,
  UserBookingCredits,
  UserCredits,
  UserCreditsSlim,
  UserDevicePushTokensPost200Response,
  UserDevicePushTokensPostRequest,
  UserFlightDeleteRequest,
  UserFlightsResponse,
  UserHotelStayDeleteRequest,
  UserPostRequest,
  UserPutRequest,
  VehicleRental,
  VehicleRentalDeleteRequest,
  VehicleRentalHistoryResponse,
  VehicleRentalRequest,
  WelcomeActions,
} from '../models/index';
import {
    AccountFromJSON,
    AccountToJSON,
    ActiveStatusChallengeResponseFromJSON,
    ActiveStatusChallengeResponseToJSON,
    AdjustCreditErrorFromJSON,
    AdjustCreditErrorToJSON,
    AdjustCreditRequestFromJSON,
    AdjustCreditRequestToJSON,
    ApplePayMerchantSessionFromJSON,
    ApplePayMerchantSessionToJSON,
    ApplePayMerchantSessionRequestFromJSON,
    ApplePayMerchantSessionRequestToJSON,
    ApplePayNotConfiguredErrorFromJSON,
    ApplePayNotConfiguredErrorToJSON,
    ApplePayTokenizedPayloadFromJSON,
    ApplePayTokenizedPayloadToJSON,
    ApplyBookingCreditsRequestFromJSON,
    ApplyBookingCreditsRequestToJSON,
    AutoSaveTriggerRequestFromJSON,
    AutoSaveTriggerRequestToJSON,
    AwardWalletAuthUrlRequestFromJSON,
    AwardWalletAuthUrlRequestToJSON,
    AwardWalletAuthUrlResponseFromJSON,
    AwardWalletAuthUrlResponseToJSON,
    AwardWalletConnectionInfoResponseFromJSON,
    AwardWalletConnectionInfoResponseToJSON,
    AwardWalletSyncResponseFromJSON,
    AwardWalletSyncResponseToJSON,
    BetterRoomsResponseFromJSON,
    BetterRoomsResponseToJSON,
    CanSendEmailRequestFromJSON,
    CanSendEmailRequestToJSON,
    CanSendEmailResponseFromJSON,
    CanSendEmailResponseToJSON,
    CreateFlightCreditRequestFromJSON,
    CreateFlightCreditRequestToJSON,
    CreateFreeNightCreditRequestFromJSON,
    CreateFreeNightCreditRequestToJSON,
    CreateSearchPresetRequestFromJSON,
    CreateSearchPresetRequestToJSON,
    CreateUpdateLoyaltyAccountRequestFromJSON,
    CreateUpdateLoyaltyAccountRequestToJSON,
    CreateUpgradeCertificateRequestFromJSON,
    CreateUpgradeCertificateRequestToJSON,
    EmailFromJSON,
    EmailToJSON,
    EmailPromotionsResponseFromJSON,
    EmailPromotionsResponseToJSON,
    ExecutiveAssistantInvitationRequestFromJSON,
    ExecutiveAssistantInvitationRequestToJSON,
    ExecutiveAssistantInvitationResponseFromJSON,
    ExecutiveAssistantInvitationResponseToJSON,
    FlightCreditFromJSON,
    FlightCreditToJSON,
    FlightCreditsResponseFromJSON,
    FlightCreditsResponseToJSON,
    FlightReservationFromJSON,
    FlightReservationToJSON,
    FreeNightCreditFromJSON,
    FreeNightCreditToJSON,
    FreeNightCreditsResponseFromJSON,
    FreeNightCreditsResponseToJSON,
    GondolaMappedResponseFromJSON,
    GondolaMappedResponseToJSON,
    HTTPBadRequestErrorFromJSON,
    HTTPBadRequestErrorToJSON,
    HTTPUnauthorizedErrorFromJSON,
    HTTPUnauthorizedErrorToJSON,
    HTTPValidationErrorFromJSON,
    HTTPValidationErrorToJSON,
    HotelFromJSON,
    HotelToJSON,
    HotelStayRequestFromJSON,
    HotelStayRequestToJSON,
    HotelStaysFromJSON,
    HotelStaysToJSON,
    InviteLinkRequestFromJSON,
    InviteLinkRequestToJSON,
    ItinerariesFromJSON,
    ItinerariesToJSON,
    LoyaltyAccountFromJSON,
    LoyaltyAccountToJSON,
    LoyaltyAccountsResponseFromJSON,
    LoyaltyAccountsResponseToJSON,
    ManageGmailRequestFromJSON,
    ManageGmailRequestToJSON,
    ManageGmailResponseFromJSON,
    ManageGmailResponseToJSON,
    ManualMxRewardCreateRequestFromJSON,
    ManualMxRewardCreateRequestToJSON,
    MemberStayRequestFromJSON,
    MemberStayRequestToJSON,
    MemberStayResponseFromJSON,
    MemberStayResponseToJSON,
    MxConnectWidgetUrlRequestFromJSON,
    MxConnectWidgetUrlRequestToJSON,
    MxConnectWidgetUrlResponseFromJSON,
    MxConnectWidgetUrlResponseToJSON,
    MxRewardFromJSON,
    MxRewardToJSON,
    MxRewardUpdateRequestFromJSON,
    MxRewardUpdateRequestToJSON,
    MxRewardsFromJSON,
    MxRewardsToJSON,
    MxSyncRequestFromJSON,
    MxSyncRequestToJSON,
    NotFoundErrorFromJSON,
    NotFoundErrorToJSON,
    PaymentMethodFromJSON,
    PaymentMethodToJSON,
    PaymentMethodPutRequestFromJSON,
    PaymentMethodPutRequestToJSON,
    ProductAnnouncementsFromJSON,
    ProductAnnouncementsToJSON,
    RatePastStayRequestFromJSON,
    RatePastStayRequestToJSON,
    RateRefreshRequestFromJSON,
    RateRefreshRequestToJSON,
    RateRefreshResponseFromJSON,
    RateRefreshResponseToJSON,
    RateUpdateRequestFromJSON,
    RateUpdateRequestToJSON,
    RateUpdateResponseFromJSON,
    RateUpdateResponseToJSON,
    RecomputeBookingCreditsRequestFromJSON,
    RecomputeBookingCreditsRequestToJSON,
    RecordEmailSentRequestFromJSON,
    RecordEmailSentRequestToJSON,
    RecordHotelRateUpdateSavingsRequestFromJSON,
    RecordHotelRateUpdateSavingsRequestToJSON,
    RecordHotelRateUpdateSavingsResponseFromJSON,
    RecordHotelRateUpdateSavingsResponseToJSON,
    ReferralFromJSON,
    ReferralToJSON,
    ReferralPreviewFromJSON,
    ReferralPreviewToJSON,
    ReferralsRequestFromJSON,
    ReferralsRequestToJSON,
    SearchPresetFromJSON,
    SearchPresetToJSON,
    SearchPresetsResponseFromJSON,
    SearchPresetsResponseToJSON,
    ServerErrorFromJSON,
    ServerErrorToJSON,
    StatusChallengeRequestFromJSON,
    StatusChallengeRequestToJSON,
    StatusChallengeResponseFromJSON,
    StatusChallengeResponseToJSON,
    StatusMatchResponseFromJSON,
    StatusMatchResponseToJSON,
    StripeCheckoutSessionRequestFromJSON,
    StripeCheckoutSessionRequestToJSON,
    StripeCheckoutSessionResponseFromJSON,
    StripeCheckoutSessionResponseToJSON,
    SubscriptionRequestFromJSON,
    SubscriptionRequestToJSON,
    SuccessResponseFromJSON,
    SuccessResponseToJSON,
    TravelHistoryResponseFromJSON,
    TravelHistoryResponseToJSON,
    TravelProfileFromJSON,
    TravelProfileToJSON,
    TravelProfileResponseFromJSON,
    TravelProfileResponseToJSON,
    TripFromJSON,
    TripToJSON,
    TripForwardingRelationshipPutRequestFromJSON,
    TripForwardingRelationshipPutRequestToJSON,
    TripForwardingRelationshipRequestFromJSON,
    TripForwardingRelationshipRequestToJSON,
    TripForwardingRelationshipResponseFromJSON,
    TripForwardingRelationshipResponseToJSON,
    TripsFromJSON,
    TripsToJSON,
    UpdateFlightCreditRequestFromJSON,
    UpdateFlightCreditRequestToJSON,
    UpdateFreeNightCreditRequestFromJSON,
    UpdateFreeNightCreditRequestToJSON,
    UpdateUpgradeCertificateRequestFromJSON,
    UpdateUpgradeCertificateRequestToJSON,
    UpgradeCertificateFromJSON,
    UpgradeCertificateToJSON,
    UpgradeCertificatesResponseFromJSON,
    UpgradeCertificatesResponseToJSON,
    UserFromJSON,
    UserToJSON,
    UserBookingCreditsFromJSON,
    UserBookingCreditsToJSON,
    UserCreditsFromJSON,
    UserCreditsToJSON,
    UserCreditsSlimFromJSON,
    UserCreditsSlimToJSON,
    UserDevicePushTokensPost200ResponseFromJSON,
    UserDevicePushTokensPost200ResponseToJSON,
    UserDevicePushTokensPostRequestFromJSON,
    UserDevicePushTokensPostRequestToJSON,
    UserFlightDeleteRequestFromJSON,
    UserFlightDeleteRequestToJSON,
    UserFlightsResponseFromJSON,
    UserFlightsResponseToJSON,
    UserHotelStayDeleteRequestFromJSON,
    UserHotelStayDeleteRequestToJSON,
    UserPostRequestFromJSON,
    UserPostRequestToJSON,
    UserPutRequestFromJSON,
    UserPutRequestToJSON,
    VehicleRentalFromJSON,
    VehicleRentalToJSON,
    VehicleRentalDeleteRequestFromJSON,
    VehicleRentalDeleteRequestToJSON,
    VehicleRentalHistoryResponseFromJSON,
    VehicleRentalHistoryResponseToJSON,
    VehicleRentalRequestFromJSON,
    VehicleRentalRequestToJSON,
    WelcomeActionsFromJSON,
    WelcomeActionsToJSON,
} from '../models/index';

export interface AutoSaveTriggerPostRequest {
    autoSaveTriggerRequest: AutoSaveTriggerRequest;
}

export interface ExecutiveAssistantInvitationsExecutiveAssistantInvitationIdDeleteRequest {
    executiveAssistantInvitationId: string;
}

export interface ExecutiveAssistantInvitationsExecutiveAssistantInvitationIdPutRequest {
    executiveAssistantInvitationId: string;
    executiveAssistantInvitationRequest: ExecutiveAssistantInvitationRequest;
}

export interface ExecutiveAssistantInvitationsPostRequest {
    executiveAssistantInvitationRequest: ExecutiveAssistantInvitationRequest;
}

export interface MemberStaysPostRequest {
    memberStayRequest: MemberStayRequest;
}

export interface PaymentMethodPutOperationRequest {
    paymentMethodId: string;
    paymentMethodPutRequest: PaymentMethodPutRequest;
    test?: boolean;
}

export interface PaymentsCheckoutSessionGetRequest {
    sessionId: string;
    test?: boolean;
}

export interface PaymentsCheckoutSessionPostRequest {
    stripeCheckoutSessionRequest: StripeCheckoutSessionRequest;
    test?: boolean;
}

export interface PublicReferralReferralCodePreviewGetRequest {
    referralCode: string;
}

export interface RateRefreshPostRequest {
    rateRefreshRequest: RateRefreshRequest;
}

export interface RateUpdateGetRequest {
    hotelStayId: string;
}

export interface RateUpdatePostRequest {
    rateUpdateRequest: RateUpdateRequest;
}

export interface RecordHotelRateUpdateSavingsOperationRequest {
    recordHotelRateUpdateSavingsRequest: RecordHotelRateUpdateSavingsRequest;
}

export interface TripForwardPostRequest {
    tripForwardingRelationshipRequest: TripForwardingRelationshipRequest;
}

export interface TripForwardPutRequest {
    tripForwardingRelationshipPutRequest: TripForwardingRelationshipPutRequest;
}

export interface UserApplePayMerchantSessionPostRequest {
    applePayMerchantSessionRequest: ApplePayMerchantSessionRequest;
}

export interface UserApplePayPaymentMethodPostRequest {
    applePayTokenizedPayload: ApplePayTokenizedPayload;
}

export interface UserBookingsBookingIdZeroCashPutRequest {
    bookingId: number;
}

export interface UserDevicePushTokensPostOperationRequest {
    userDevicePushTokensPostRequest?: UserDevicePushTokensPostRequest;
}

export interface UserDevicePushTokensTokenDeleteRequest {
    token: string;
}

export interface UserFlightDeleteOperationRequest {
    userFlightDeleteRequest?: UserFlightDeleteRequest;
}

export interface UserFlightPostRequest {
    flightReservation: FlightReservation;
}

export interface UserFlightPutRequest {
    flightReservation: FlightReservation;
}

export interface UserHotelStayDeleteOperationRequest {
    userHotelStayDeleteRequest?: UserHotelStayDeleteRequest;
}

export interface UserHotelStayPostRequest {
    hotelStayRequest: HotelStayRequest;
}

export interface UserHotelStayPutRequest {
    hotelStayRequest: HotelStayRequest;
}

export interface UserHotelStaysStayIdBetterRoomsGetRequest {
    stayId: string;
}

export interface UserLoyaltyAccountsGetRequest {
    extended?: boolean;
}

export interface UserManageGmailAccountPostRequest {
    manageGmailRequest: ManageGmailRequest;
}

export interface UserPaymentMethodsGetRequest {
    test?: boolean;
}

export interface UserPaymentMethodsPaymentMethodIdDeleteRequest {
    paymentMethodId: string;
}

export interface UserPaymentMethodsPaymentMethodIdGetRequest {
    paymentMethodId: string;
    test?: boolean;
}

export interface UserPaymentMethodsPostRequest {
    paymentMethod: PaymentMethod;
    test?: boolean;
}

export interface UserPostOperationRequest {
    userPostRequest?: UserPostRequest;
}

export interface UserPutOperationRequest {
    userPutRequest?: UserPutRequest;
}

export interface UserSearchPresetsPostRequest {
    createSearchPresetRequest: CreateSearchPresetRequest;
}

export interface UserSearchPresetsPresetIdDeleteRequest {
    presetId: string;
}

export interface UserStatusChallengePostRequest {
    statusChallengeRequest: StatusChallengeRequest;
}

export interface UserTravelProfilesPostRequest {
    travelProfile: TravelProfile;
}

export interface UserTravelProfilesTravelProfileIdDeleteRequest {
    travelProfileId: string;
}

export interface UserTravelProfilesTravelProfileIdGetRequest {
    travelProfileId: string;
}

export interface UserTravelProfilesTravelProfileIdPutRequest {
    travelProfileId: string;
    travelProfile: TravelProfile;
}

export interface UserTripsHotelsBookingsBookingIdPutRequest {
    bookingId: string;
}

export interface UserTripsPostRequest {
    trip: Trip;
}

export interface UserTripsVehiclesDeleteRequest {
    vehicleRentalDeleteRequest: VehicleRentalDeleteRequest;
}

export interface UserTripsVehiclesGondolaBookingIdCancelPutRequest {
    gondolaBookingId: string;
}

export interface UserTripsVehiclesPostRequest {
    vehicleRentalRequest: VehicleRentalRequest;
}

export interface UserTripsVehiclesPutRequest {
    vehicleRentalRequest: VehicleRentalRequest;
}

export interface UsersAwardwalletAuthUrlsPostRequest {
    awardWalletAuthUrlRequest: AwardWalletAuthUrlRequest;
}

export interface UsersAwardwalletCallbackGetRequest {
    code: string;
    state: string;
}

export interface UsersCreditsBookingsBookingIdPostRequest {
    bookingId: number;
    applyBookingCreditsRequest: ApplyBookingCreditsRequest;
}

export interface UsersCreditsBookingsBookingIdPutRequest {
    bookingId: number;
    adjustCreditRequest: AdjustCreditRequest;
}

export interface UsersCreditsBookingsBookingIdRecomputePostRequest {
    bookingId: number;
    recomputeBookingCreditsRequest: RecomputeBookingCreditsRequest;
}

export interface UsersEmailsCanSendPostRequest {
    canSendEmailRequest: CanSendEmailRequest;
}

export interface UsersEmailsPostRequest {
    recordEmailSentRequest: RecordEmailSentRequest;
}

export interface UsersGondolaMappedYearYearGetRequest {
    year: number;
}

export interface UsersInvitesLinkPostRequest {
    inviteLinkRequest: InviteLinkRequest;
}

export interface UsersInvitesPostRequest {
    referralsRequest: ReferralsRequest;
}

export interface UsersMxConnectWidgetUrlsPostRequest {
    mxConnectWidgetUrlRequest: MxConnectWidgetUrlRequest;
}

export interface UsersMxRewardsMxRewardIdDeleteRequest {
    mxRewardId: number;
}

export interface UsersMxRewardsMxRewardIdPutRequest {
    mxRewardId: string;
    mxRewardUpdateRequest: MxRewardUpdateRequest;
}

export interface UsersMxRewardsPostRequest {
    manualMxRewardCreateRequest: ManualMxRewardCreateRequest;
}

export interface UsersMxRewardsRewardsProgramsNameGetRequest {
    name: string;
}

export interface UsersMxSyncPostRequest {
    mxSyncRequest: MxSyncRequest;
}

export interface UsersSubscriptionsPutRequest {
    subscriptionRequest: SubscriptionRequest;
}

export interface UsersUserIdAccountsAccountIdDeleteRequest {
    userId: string;
    accountId: string;
}

export interface UsersUserIdBookingsBookingIdRatePastStayPutRequest {
    userId: string;
    bookingId: number;
    ratePastStayRequest: RatePastStayRequest;
}

export interface UsersUserIdProductAnnouncementsAnnouncementIdReadPutRequest {
    userId: string;
    announcementId: string;
}

export interface UsersUserIdProductAnnouncementsGetRequest {
    userId: string;
}

export interface UsersUserIdWelcomeActionsGetRequest {
    userId: string;
}

export interface UsersUserIdWelcomeActionsWelcomeActionIdDeleteRequest {
    userId: string;
    welcomeActionId: number;
}

export interface V2UserEmailPromotionsPromotionIdDeleteRequest {
    promotionId: string;
}

export interface V2UserFlightCreditsCreditIdDeleteRequest {
    creditId: string;
}

export interface V2UserFlightCreditsCreditIdPutRequest {
    creditId: string;
    updateFlightCreditRequest: UpdateFlightCreditRequest;
}

export interface V2UserFlightCreditsPostRequest {
    createFlightCreditRequest: CreateFlightCreditRequest;
}

export interface V2UserFreeNightCreditsCreditIdDeleteRequest {
    creditId: string;
}

export interface V2UserFreeNightCreditsCreditIdPutRequest {
    creditId: string;
    updateFreeNightCreditRequest: UpdateFreeNightCreditRequest;
}

export interface V2UserFreeNightCreditsPostRequest {
    createFreeNightCreditRequest: CreateFreeNightCreditRequest;
}

export interface V2UserLoyaltyAccountsGetRequest {
    extended?: boolean;
}

export interface V2UserLoyaltyAccountsLoyaltyAccountIdDeleteRequest {
    loyaltyAccountId: string;
}

export interface V2UserLoyaltyAccountsLoyaltyAccountIdPutRequest {
    loyaltyAccountId: string;
    createUpdateLoyaltyAccountRequest: CreateUpdateLoyaltyAccountRequest;
}

export interface V2UserLoyaltyAccountsPostRequest {
    createUpdateLoyaltyAccountRequest: CreateUpdateLoyaltyAccountRequest;
}

export interface V2UserUpgradeCertificatesCertificateIdDeleteRequest {
    certificateId: string;
}

export interface V2UserUpgradeCertificatesCertificateIdPutRequest {
    certificateId: string;
    updateUpgradeCertificateRequest: UpdateUpgradeCertificateRequest;
}

export interface V2UserUpgradeCertificatesPostRequest {
    createUpgradeCertificateRequest: CreateUpgradeCertificateRequest;
}

export interface V2UserVehiclesHistoryGetRequest {
    limit?: number;
}

/**
 * 
 */
export class UserApi extends runtime.BaseAPI {

    /**
     * Trigger the auto-save workflow for a Gondola reservation.
     */
    async autoSaveTriggerPostRaw(requestParameters: AutoSaveTriggerPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RateUpdateResponse>> {
        if (requestParameters['autoSaveTriggerRequest'] == null) {
            throw new runtime.RequiredError(
                'autoSaveTriggerRequest',
                'Required parameter "autoSaveTriggerRequest" was null or undefined when calling autoSaveTriggerPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2PasswordBearer", []);
        }


        let urlPath = `/auto_save_trigger`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AutoSaveTriggerRequestToJSON(requestParameters['autoSaveTriggerRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RateUpdateResponseFromJSON(jsonValue));
    }

    /**
     * Trigger the auto-save workflow for a Gondola reservation.
     */
    async autoSaveTriggerPost(requestParameters: AutoSaveTriggerPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RateUpdateResponse> {
        const response = await this.autoSaveTriggerPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Delete an executive assistant invitation.
     */
    async executiveAssistantInvitationsExecutiveAssistantInvitationIdDeleteRaw(requestParameters: ExecutiveAssistantInvitationsExecutiveAssistantInvitationIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['executiveAssistantInvitationId'] == null) {
            throw new runtime.RequiredError(
                'executiveAssistantInvitationId',
                'Required parameter "executiveAssistantInvitationId" was null or undefined when calling executiveAssistantInvitationsExecutiveAssistantInvitationIdDelete().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2PasswordBearer", []);
        }


        let urlPath = `/executive_assistant_invitations/{executive_assistant_invitation_id}`;
        urlPath = urlPath.replace(`{${"executive_assistant_invitation_id"}}`, encodeURIComponent(String(requestParameters['executiveAssistantInvitationId'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete an executive assistant invitation.
     */
    async executiveAssistantInvitationsExecutiveAssistantInvitationIdDelete(requestParameters: ExecutiveAssistantInvitationsExecutiveAssistantInvitationIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.executiveAssistantInvitationsExecutiveAssistantInvitationIdDeleteRaw(requestParameters, initOverrides);
    }

    /**
     * Update an executive assistant invitation.
     */
    async executiveAssistantInvitationsExecutiveAssistantInvitationIdPutRaw(requestParameters: ExecutiveAssistantInvitationsExecutiveAssistantInvitationIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ExecutiveAssistantInvitationResponse>> {
        if (requestParameters['executiveAssistantInvitationId'] == null) {
            throw new runtime.RequiredError(
                'executiveAssistantInvitationId',
                'Required parameter "executiveAssistantInvitationId" was null or undefined when calling executiveAssistantInvitationsExecutiveAssistantInvitationIdPut().'
            );
        }

        if (requestParameters['executiveAssistantInvitationRequest'] == null) {
            throw new runtime.RequiredError(
                'executiveAssistantInvitationRequest',
                'Required parameter "executiveAssistantInvitationRequest" was null or undefined when calling executiveAssistantInvitationsExecutiveAssistantInvitationIdPut().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2PasswordBearer", []);
        }


        let urlPath = `/executive_assistant_invitations/{executive_assistant_invitation_id}`;
        urlPath = urlPath.replace(`{${"executive_assistant_invitation_id"}}`, encodeURIComponent(String(requestParameters['executiveAssistantInvitationId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: ExecutiveAssistantInvitationRequestToJSON(requestParameters['executiveAssistantInvitationRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ExecutiveAssistantInvitationResponseFromJSON(jsonValue));
    }

    /**
     * Update an executive assistant invitation.
     */
    async executiveAssistantInvitationsExecutiveAssistantInvitationIdPut(requestParameters: ExecutiveAssistantInvitationsExecutiveAssistantInvitationIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ExecutiveAssistantInvitationResponse> {
        const response = await this.executiveAssistantInvitationsExecutiveAssistantInvitationIdPutRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get executive assistant invitations.
     */
    async executiveAssistantInvitationsGetRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ExecutiveAssistantInvitationResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2PasswordBearer", []);
        }


        let urlPath = `/executive_assistant_invitations`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ExecutiveAssistantInvitationResponseFromJSON(jsonValue));
    }

    /**
     * Get executive assistant invitations.
     */
    async executiveAssistantInvitationsGet(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ExecutiveAssistantInvitationResponse> {
        const response = await this.executiveAssistantInvitationsGetRaw(initOverrides);
        return await response.value();
    }

    /**
     * Create an executive assistant invitation.
     */
    async executiveAssistantInvitationsPostRaw(requestParameters: ExecutiveAssistantInvitationsPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ExecutiveAssistantInvitationResponse>> {
        if (requestParameters['executiveAssistantInvitationRequest'] == null) {
            throw new runtime.RequiredError(
                'executiveAssistantInvitationRequest',
                'Required parameter "executiveAssistantInvitationRequest" was null or undefined when calling executiveAssistantInvitationsPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2PasswordBearer", []);
        }


        let urlPath = `/executive_assistant_invitations`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ExecutiveAssistantInvitationRequestToJSON(requestParameters['executiveAssistantInvitationRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ExecutiveAssistantInvitationResponseFromJSON(jsonValue));
    }

    /**
     * Create an executive assistant invitation.
     */
    async executiveAssistantInvitationsPost(requestParameters: ExecutiveAssistantInvitationsPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ExecutiveAssistantInvitationResponse> {
        const response = await this.executiveAssistantInvitationsPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get member stays.
     */
    async memberStaysPostRaw(requestParameters: MemberStaysPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MemberStayResponse>> {
        if (requestParameters['memberStayRequest'] == null) {
            throw new runtime.RequiredError(
                'memberStayRequest',
                'Required parameter "memberStayRequest" was null or undefined when calling memberStaysPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2PasswordBearer", []);
        }


        let urlPath = `/member_stays`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: MemberStayRequestToJSON(requestParameters['memberStayRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MemberStayResponseFromJSON(jsonValue));
    }

    /**
     * Get member stays.
     */
    async memberStaysPost(requestParameters: MemberStaysPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MemberStayResponse> {
        const response = await this.memberStaysPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update payment method values
     */
    async paymentMethodPutRaw(requestParameters: PaymentMethodPutOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PaymentMethod>> {
        if (requestParameters['paymentMethodId'] == null) {
            throw new runtime.RequiredError(
                'paymentMethodId',
                'Required parameter "paymentMethodId" was null or undefined when calling paymentMethodPut().'
            );
        }

        if (requestParameters['paymentMethodPutRequest'] == null) {
            throw new runtime.RequiredError(
                'paymentMethodPutRequest',
                'Required parameter "paymentMethodPutRequest" was null or undefined when calling paymentMethodPut().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['test'] != null) {
            queryParameters['test'] = requestParameters['test'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2PasswordBearer", []);
        }


        let urlPath = `/user/payment_methods/{payment_method_id}`;
        urlPath = urlPath.replace(`{${"payment_method_id"}}`, encodeURIComponent(String(requestParameters['paymentMethodId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: PaymentMethodPutRequestToJSON(requestParameters['paymentMethodPutRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaymentMethodFromJSON(jsonValue));
    }

    /**
     * Update payment method values
     */
    async paymentMethodPut(requestParameters: PaymentMethodPutOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PaymentMethod> {
        const response = await this.paymentMethodPutRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get a checkout session.
     */
    async paymentsCheckoutSessionGetRaw(requestParameters: PaymentsCheckoutSessionGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<StripeCheckoutSessionResponse>> {
        if (requestParameters['sessionId'] == null) {
            throw new runtime.RequiredError(
                'sessionId',
                'Required parameter "sessionId" was null or undefined when calling paymentsCheckoutSessionGet().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['session_id'] = requestParameters['sessionId'];
        }

        if (requestParameters['test'] != null) {
            queryParameters['test'] = requestParameters['test'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2PasswordBearer", []);
        }


        let urlPath = `/payments/checkout_session`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => StripeCheckoutSessionResponseFromJSON(jsonValue));
    }

    /**
     * Get a checkout session.
     */
    async paymentsCheckoutSessionGet(requestParameters: PaymentsCheckoutSessionGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<StripeCheckoutSessionResponse> {
        const response = await this.paymentsCheckoutSessionGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create a checkout session.
     */
    async paymentsCheckoutSessionPostRaw(requestParameters: PaymentsCheckoutSessionPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<StripeCheckoutSessionResponse>> {
        if (requestParameters['stripeCheckoutSessionRequest'] == null) {
            throw new runtime.RequiredError(
                'stripeCheckoutSessionRequest',
                'Required parameter "stripeCheckoutSessionRequest" was null or undefined when calling paymentsCheckoutSessionPost().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['test'] != null) {
            queryParameters['test'] = requestParameters['test'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2PasswordBearer", []);
        }


        let urlPath = `/payments/checkout_session`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: StripeCheckoutSessionRequestToJSON(requestParameters['stripeCheckoutSessionRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => StripeCheckoutSessionResponseFromJSON(jsonValue));
    }

    /**
     * Create a checkout session.
     */
    async paymentsCheckoutSessionPost(requestParameters: PaymentsCheckoutSessionPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<StripeCheckoutSessionResponse> {
        const response = await this.paymentsCheckoutSessionPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Returns the amount (in USD) a referred person would get for this referral code. Used for link preview (og:title). No authentication required.
     */
    async publicReferralReferralCodePreviewGetRaw(requestParameters: PublicReferralReferralCodePreviewGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ReferralPreview>> {
        if (requestParameters['referralCode'] == null) {
            throw new runtime.RequiredError(
                'referralCode',
                'Required parameter "referralCode" was null or undefined when calling publicReferralReferralCodePreviewGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/public/referral/{referral_code}/preview`;
        urlPath = urlPath.replace(`{${"referral_code"}}`, encodeURIComponent(String(requestParameters['referralCode'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ReferralPreviewFromJSON(jsonValue));
    }

    /**
     * Returns the amount (in USD) a referred person would get for this referral code. Used for link preview (og:title). No authentication required.
     */
    async publicReferralReferralCodePreviewGet(requestParameters: PublicReferralReferralCodePreviewGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ReferralPreview> {
        const response = await this.publicReferralReferralCodePreviewGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Enqueue a fresh rate check for a monitored reservation (hotel stay or flight).
     */
    async rateRefreshPostRaw(requestParameters: RateRefreshPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RateRefreshResponse>> {
        if (requestParameters['rateRefreshRequest'] == null) {
            throw new runtime.RequiredError(
                'rateRefreshRequest',
                'Required parameter "rateRefreshRequest" was null or undefined when calling rateRefreshPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2PasswordBearer", []);
        }


        let urlPath = `/rate_refresh`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RateRefreshRequestToJSON(requestParameters['rateRefreshRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RateRefreshResponseFromJSON(jsonValue));
    }

    /**
     * Enqueue a fresh rate check for a monitored reservation (hotel stay or flight).
     */
    async rateRefreshPost(requestParameters: RateRefreshPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RateRefreshResponse> {
        const response = await this.rateRefreshPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get rate update requests.
     */
    async rateUpdateGetRaw(requestParameters: RateUpdateGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RateUpdateResponse>> {
        if (requestParameters['hotelStayId'] == null) {
            throw new runtime.RequiredError(
                'hotelStayId',
                'Required parameter "hotelStayId" was null or undefined when calling rateUpdateGet().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['hotelStayId'] != null) {
            queryParameters['hotel_stay_id'] = requestParameters['hotelStayId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2PasswordBearer", []);
        }


        let urlPath = `/rate_update`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RateUpdateResponseFromJSON(jsonValue));
    }

    /**
     * Get rate update requests.
     */
    async rateUpdateGet(requestParameters: RateUpdateGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RateUpdateResponse> {
        const response = await this.rateUpdateGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create a rate update request.
     */
    async rateUpdatePostRaw(requestParameters: RateUpdatePostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RateUpdateResponse>> {
        if (requestParameters['rateUpdateRequest'] == null) {
            throw new runtime.RequiredError(
                'rateUpdateRequest',
                'Required parameter "rateUpdateRequest" was null or undefined when calling rateUpdatePost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2PasswordBearer", []);
        }


        let urlPath = `/rate_update`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RateUpdateRequestToJSON(requestParameters['rateUpdateRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RateUpdateResponseFromJSON(jsonValue));
    }

    /**
     * Create a rate update request.
     */
    async rateUpdatePost(requestParameters: RateUpdatePostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RateUpdateResponse> {
        const response = await this.rateUpdatePostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Record a savings event in user_savings_ledger for a hotel rate update (auto-save, boost, or user-initiated). The handler loads both old and new user_hotel_stays, derives the savings type from old.booking_agent + price comparison, computes USD amounts, and writes one row. Idempotent on (savings_type, booking_id).
     */
    async recordHotelRateUpdateSavingsRaw(requestParameters: RecordHotelRateUpdateSavingsOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RecordHotelRateUpdateSavingsResponse>> {
        if (requestParameters['recordHotelRateUpdateSavingsRequest'] == null) {
            throw new runtime.RequiredError(
                'recordHotelRateUpdateSavingsRequest',
                'Required parameter "recordHotelRateUpdateSavingsRequest" was null or undefined when calling recordHotelRateUpdateSavings().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2PasswordBearer", []);
        }


        let urlPath = `/users/savings/hotel-rate-update`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RecordHotelRateUpdateSavingsRequestToJSON(requestParameters['recordHotelRateUpdateSavingsRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RecordHotelRateUpdateSavingsResponseFromJSON(jsonValue));
    }

    /**
     * Record a savings event in user_savings_ledger for a hotel rate update (auto-save, boost, or user-initiated). The handler loads both old and new user_hotel_stays, derives the savings type from old.booking_agent + price comparison, computes USD amounts, and writes one row. Idempotent on (savings_type, booking_id).
     */
    async recordHotelRateUpdateSavings(requestParameters: RecordHotelRateUpdateSavingsOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RecordHotelRateUpdateSavingsResponse> {
        const response = await this.recordHotelRateUpdateSavingsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get the trip forwarding relationships for the current user.
     */
    async tripForwardGetRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TripForwardingRelationshipResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2PasswordBearer", []);
        }


        let urlPath = `/trip_forward`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TripForwardingRelationshipResponseFromJSON(jsonValue));
    }

    /**
     * Get the trip forwarding relationships for the current user.
     */
    async tripForwardGet(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TripForwardingRelationshipResponse> {
        const response = await this.tripForwardGetRaw(initOverrides);
        return await response.value();
    }

    /**
     * Link a trip forwarding relationship to the current user.
     */
    async tripForwardPostRaw(requestParameters: TripForwardPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TripForwardingRelationshipResponse>> {
        if (requestParameters['tripForwardingRelationshipRequest'] == null) {
            throw new runtime.RequiredError(
                'tripForwardingRelationshipRequest',
                'Required parameter "tripForwardingRelationshipRequest" was null or undefined when calling tripForwardPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2PasswordBearer", []);
        }


        let urlPath = `/trip_forward`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: TripForwardingRelationshipRequestToJSON(requestParameters['tripForwardingRelationshipRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TripForwardingRelationshipResponseFromJSON(jsonValue));
    }

    /**
     * Link a trip forwarding relationship to the current user.
     */
    async tripForwardPost(requestParameters: TripForwardPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TripForwardingRelationshipResponse> {
        const response = await this.tripForwardPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Verify a trip forwarding relationship.
     */
    async tripForwardPutRaw(requestParameters: TripForwardPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TripForwardingRelationshipResponse>> {
        if (requestParameters['tripForwardingRelationshipPutRequest'] == null) {
            throw new runtime.RequiredError(
                'tripForwardingRelationshipPutRequest',
                'Required parameter "tripForwardingRelationshipPutRequest" was null or undefined when calling tripForwardPut().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2PasswordBearer", []);
        }


        let urlPath = `/trip_forward`;

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: TripForwardingRelationshipPutRequestToJSON(requestParameters['tripForwardingRelationshipPutRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TripForwardingRelationshipResponseFromJSON(jsonValue));
    }

    /**
     * Verify a trip forwarding relationship.
     */
    async tripForwardPut(requestParameters: TripForwardPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TripForwardingRelationshipResponse> {
        const response = await this.tripForwardPutRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Returns an Apple Pay merchant session for the client to present the Apple Pay sheet. Requires Apple Pay Merchant Identity certificate to be configured. 
     */
    async userApplePayMerchantSessionPostRaw(requestParameters: UserApplePayMerchantSessionPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ApplePayMerchantSession>> {
        if (requestParameters['applePayMerchantSessionRequest'] == null) {
            throw new runtime.RequiredError(
                'applePayMerchantSessionRequest',
                'Required parameter "applePayMerchantSessionRequest" was null or undefined when calling userApplePayMerchantSessionPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2PasswordBearer", []);
        }


        let urlPath = `/user/apple_pay/merchant_session`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ApplePayMerchantSessionRequestToJSON(requestParameters['applePayMerchantSessionRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ApplePayMerchantSessionFromJSON(jsonValue));
    }

    /**
     * Returns an Apple Pay merchant session for the client to present the Apple Pay sheet. Requires Apple Pay Merchant Identity certificate to be configured. 
     */
    async userApplePayMerchantSessionPost(requestParameters: UserApplePayMerchantSessionPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ApplePayMerchantSession> {
        const response = await this.userApplePayMerchantSessionPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Registers a payment method from Apple Pay using the VGS inbound route flow. The client POSTs the raw Apple Pay token to the VGS inbound route (with Authorization header); VGS decrypts, tokenizes, and forwards the payload to this endpoint. Request body is the tokenized payload forwarded by VGS (tokenized card and billing fields). 
     */
    async userApplePayPaymentMethodPostRaw(requestParameters: UserApplePayPaymentMethodPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PaymentMethod>> {
        if (requestParameters['applePayTokenizedPayload'] == null) {
            throw new runtime.RequiredError(
                'applePayTokenizedPayload',
                'Required parameter "applePayTokenizedPayload" was null or undefined when calling userApplePayPaymentMethodPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2PasswordBearer", []);
        }


        let urlPath = `/user/apple_pay/payment_method`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ApplePayTokenizedPayloadToJSON(requestParameters['applePayTokenizedPayload']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaymentMethodFromJSON(jsonValue));
    }

    /**
     * Registers a payment method from Apple Pay using the VGS inbound route flow. The client POSTs the raw Apple Pay token to the VGS inbound route (with Authorization header); VGS decrypts, tokenizes, and forwards the payload to this endpoint. Request body is the tokenized payload forwarded by VGS (tokenized card and billing fields). 
     */
    async userApplePayPaymentMethodPost(requestParameters: UserApplePayPaymentMethodPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PaymentMethod> {
        const response = await this.userApplePayPaymentMethodPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Zero reward ledger entry amounts for a booking. Used when a booking is non-commissionable.
     */
    async userBookingsBookingIdZeroCashPutRaw(requestParameters: UserBookingsBookingIdZeroCashPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['bookingId'] == null) {
            throw new runtime.RequiredError(
                'bookingId',
                'Required parameter "bookingId" was null or undefined when calling userBookingsBookingIdZeroCashPut().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2PasswordBearer", []);
        }


        let urlPath = `/user/bookings/{booking_id}/zero-cash`;
        urlPath = urlPath.replace(`{${"booking_id"}}`, encodeURIComponent(String(requestParameters['bookingId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Zero reward ledger entry amounts for a booking. Used when a booking is non-commissionable.
     */
    async userBookingsBookingIdZeroCashPut(requestParameters: UserBookingsBookingIdZeroCashPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.userBookingsBookingIdZeroCashPutRaw(requestParameters, initOverrides);
    }

    /**
     * Register or update a device token for push notifications.
     */
    async userDevicePushTokensPostRaw(requestParameters: UserDevicePushTokensPostOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UserDevicePushTokensPost200Response>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2PasswordBearer", []);
        }


        let urlPath = `/user/device_push_tokens`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: UserDevicePushTokensPostRequestToJSON(requestParameters['userDevicePushTokensPostRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UserDevicePushTokensPost200ResponseFromJSON(jsonValue));
    }

    /**
     * Register or update a device token for push notifications.
     */
    async userDevicePushTokensPost(requestParameters: UserDevicePushTokensPostOperationRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UserDevicePushTokensPost200Response> {
        const response = await this.userDevicePushTokensPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Unregister a device token for push notifications.
     */
    async userDevicePushTokensTokenDeleteRaw(requestParameters: UserDevicePushTokensTokenDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UserDevicePushTokensPost200Response>> {
        if (requestParameters['token'] == null) {
            throw new runtime.RequiredError(
                'token',
                'Required parameter "token" was null or undefined when calling userDevicePushTokensTokenDelete().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2PasswordBearer", []);
        }


        let urlPath = `/user/device_push_tokens/{token}`;
        urlPath = urlPath.replace(`{${"token"}}`, encodeURIComponent(String(requestParameters['token'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UserDevicePushTokensPost200ResponseFromJSON(jsonValue));
    }

    /**
     * Unregister a device token for push notifications.
     */
    async userDevicePushTokensTokenDelete(requestParameters: UserDevicePushTokensTokenDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UserDevicePushTokensPost200Response> {
        const response = await this.userDevicePushTokensTokenDeleteRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Delete a user\'s flight.
     */
    async userFlightDeleteRaw(requestParameters: UserFlightDeleteOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SuccessResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2PasswordBearer", []);
        }


        let urlPath = `/user/flight`;

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
            body: UserFlightDeleteRequestToJSON(requestParameters['userFlightDeleteRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SuccessResponseFromJSON(jsonValue));
    }

    /**
     * Delete a user\'s flight.
     */
    async userFlightDelete(requestParameters: UserFlightDeleteOperationRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SuccessResponse> {
        const response = await this.userFlightDeleteRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get a user\'s flight.
     */
    async userFlightGetRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UserFlightsResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2PasswordBearer", []);
        }


        let urlPath = `/user/flight`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UserFlightsResponseFromJSON(jsonValue));
    }

    /**
     * Get a user\'s flight.
     */
    async userFlightGet(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UserFlightsResponse> {
        const response = await this.userFlightGetRaw(initOverrides);
        return await response.value();
    }

    /**
     * Create a user\'s flight.
     */
    async userFlightPostRaw(requestParameters: UserFlightPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Itineraries>> {
        if (requestParameters['flightReservation'] == null) {
            throw new runtime.RequiredError(
                'flightReservation',
                'Required parameter "flightReservation" was null or undefined when calling userFlightPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2PasswordBearer", []);
        }


        let urlPath = `/user/flight`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: FlightReservationToJSON(requestParameters['flightReservation']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ItinerariesFromJSON(jsonValue));
    }

    /**
     * Create a user\'s flight.
     */
    async userFlightPost(requestParameters: UserFlightPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Itineraries> {
        const response = await this.userFlightPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update a user\'s flight.
     */
    async userFlightPutRaw(requestParameters: UserFlightPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Itineraries>> {
        if (requestParameters['flightReservation'] == null) {
            throw new runtime.RequiredError(
                'flightReservation',
                'Required parameter "flightReservation" was null or undefined when calling userFlightPut().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2PasswordBearer", []);
        }


        let urlPath = `/user/flight`;

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: FlightReservationToJSON(requestParameters['flightReservation']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ItinerariesFromJSON(jsonValue));
    }

    /**
     * Update a user\'s flight.
     */
    async userFlightPut(requestParameters: UserFlightPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Itineraries> {
        const response = await this.userFlightPutRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get a user\'s flights.
     */
    async userFlightsGetRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UserFlightsResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2PasswordBearer", []);
        }


        let urlPath = `/user/flights`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UserFlightsResponseFromJSON(jsonValue));
    }

    /**
     * Get a user\'s flights.
     */
    async userFlightsGet(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UserFlightsResponse> {
        const response = await this.userFlightsGetRaw(initOverrides);
        return await response.value();
    }

    /**
     * Read User
     */
    async userGetRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<User>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2PasswordBearer", []);
        }


        let urlPath = `/user`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UserFromJSON(jsonValue));
    }

    /**
     * Read User
     */
    async userGet(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<User> {
        const response = await this.userGetRaw(initOverrides);
        return await response.value();
    }

    /**
     * Delete a user\'s hotel stay.
     */
    async userHotelStayDeleteRaw(requestParameters: UserHotelStayDeleteOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SuccessResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2PasswordBearer", []);
        }


        let urlPath = `/user/hotel_stay`;

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
            body: UserHotelStayDeleteRequestToJSON(requestParameters['userHotelStayDeleteRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SuccessResponseFromJSON(jsonValue));
    }

    /**
     * Delete a user\'s hotel stay.
     */
    async userHotelStayDelete(requestParameters: UserHotelStayDeleteOperationRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SuccessResponse> {
        const response = await this.userHotelStayDeleteRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create a user\'s hotel stay.
     */
    async userHotelStayPostRaw(requestParameters: UserHotelStayPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Itineraries>> {
        if (requestParameters['hotelStayRequest'] == null) {
            throw new runtime.RequiredError(
                'hotelStayRequest',
                'Required parameter "hotelStayRequest" was null or undefined when calling userHotelStayPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2PasswordBearer", []);
        }


        let urlPath = `/user/hotel_stay`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: HotelStayRequestToJSON(requestParameters['hotelStayRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ItinerariesFromJSON(jsonValue));
    }

    /**
     * Create a user\'s hotel stay.
     */
    async userHotelStayPost(requestParameters: UserHotelStayPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Itineraries> {
        const response = await this.userHotelStayPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update a user\'s hotel stay.
     */
    async userHotelStayPutRaw(requestParameters: UserHotelStayPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Itineraries>> {
        if (requestParameters['hotelStayRequest'] == null) {
            throw new runtime.RequiredError(
                'hotelStayRequest',
                'Required parameter "hotelStayRequest" was null or undefined when calling userHotelStayPut().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2PasswordBearer", []);
        }


        let urlPath = `/user/hotel_stay`;

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: HotelStayRequestToJSON(requestParameters['hotelStayRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ItinerariesFromJSON(jsonValue));
    }

    /**
     * Update a user\'s hotel stay.
     */
    async userHotelStayPut(requestParameters: UserHotelStayPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Itineraries> {
        const response = await this.userHotelStayPutRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get a user\'s hotel stays.
     */
    async userHotelStaysGetRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<HotelStays>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2PasswordBearer", []);
        }


        let urlPath = `/user/hotel_stays`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => HotelStaysFromJSON(jsonValue));
    }

    /**
     * Get a user\'s hotel stays.
     */
    async userHotelStaysGet(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<HotelStays> {
        const response = await this.userHotelStaysGetRaw(initOverrides);
        return await response.value();
    }

    /**
     * Get the LLM-ranked top 3 better rooms available for a user\'s upcoming stay, plus the full list of all available higher-tier rooms. Backed by a 24h Redis cache populated by the daily `check_trip_room_availability` Celery task; the ranking is computed once during the refresh and reused on every modal open. 
     */
    async userHotelStaysStayIdBetterRoomsGetRaw(requestParameters: UserHotelStaysStayIdBetterRoomsGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BetterRoomsResponse>> {
        if (requestParameters['stayId'] == null) {
            throw new runtime.RequiredError(
                'stayId',
                'Required parameter "stayId" was null or undefined when calling userHotelStaysStayIdBetterRoomsGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2PasswordBearer", []);
        }


        let urlPath = `/user/hotel_stays/{stay_id}/better_rooms`;
        urlPath = urlPath.replace(`{${"stay_id"}}`, encodeURIComponent(String(requestParameters['stayId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => BetterRoomsResponseFromJSON(jsonValue));
    }

    /**
     * Get the LLM-ranked top 3 better rooms available for a user\'s upcoming stay, plus the full list of all available higher-tier rooms. Backed by a 24h Redis cache populated by the daily `check_trip_room_availability` Celery task; the ranking is computed once during the refresh and reused on every modal open. 
     */
    async userHotelStaysStayIdBetterRoomsGet(requestParameters: UserHotelStaysStayIdBetterRoomsGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<BetterRoomsResponse> {
        const response = await this.userHotelStaysStayIdBetterRoomsGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Read a user\'s loyalty accounts
     */
    async userLoyaltyAccountsGetRaw(requestParameters: UserLoyaltyAccountsGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<LoyaltyAccount>>> {
        const queryParameters: any = {};

        if (requestParameters['extended'] != null) {
            queryParameters['extended'] = requestParameters['extended'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2PasswordBearer", []);
        }


        let urlPath = `/user/loyalty_accounts`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(LoyaltyAccountFromJSON));
    }

    /**
     * Read a user\'s loyalty accounts
     */
    async userLoyaltyAccountsGet(requestParameters: UserLoyaltyAccountsGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<LoyaltyAccount>> {
        const response = await this.userLoyaltyAccountsGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Manage gmail account - validate, disconnect, delete
     */
    async userManageGmailAccountPostRaw(requestParameters: UserManageGmailAccountPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ManageGmailResponse>> {
        if (requestParameters['manageGmailRequest'] == null) {
            throw new runtime.RequiredError(
                'manageGmailRequest',
                'Required parameter "manageGmailRequest" was null or undefined when calling userManageGmailAccountPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2PasswordBearer", []);
        }


        let urlPath = `/user/manage_gmail_account`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ManageGmailRequestToJSON(requestParameters['manageGmailRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ManageGmailResponseFromJSON(jsonValue));
    }

    /**
     * Manage gmail account - validate, disconnect, delete
     */
    async userManageGmailAccountPost(requestParameters: UserManageGmailAccountPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ManageGmailResponse> {
        const response = await this.userManageGmailAccountPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get a user\'s payment methods.
     */
    async userPaymentMethodsGetRaw(requestParameters: UserPaymentMethodsGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<PaymentMethod>>> {
        const queryParameters: any = {};

        if (requestParameters['test'] != null) {
            queryParameters['test'] = requestParameters['test'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2PasswordBearer", []);
        }


        let urlPath = `/user/payment_methods`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(PaymentMethodFromJSON));
    }

    /**
     * Get a user\'s payment methods.
     */
    async userPaymentMethodsGet(requestParameters: UserPaymentMethodsGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<PaymentMethod>> {
        const response = await this.userPaymentMethodsGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Delete a payment method.
     */
    async userPaymentMethodsPaymentMethodIdDeleteRaw(requestParameters: UserPaymentMethodsPaymentMethodIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SuccessResponse>> {
        if (requestParameters['paymentMethodId'] == null) {
            throw new runtime.RequiredError(
                'paymentMethodId',
                'Required parameter "paymentMethodId" was null or undefined when calling userPaymentMethodsPaymentMethodIdDelete().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2PasswordBearer", []);
        }


        let urlPath = `/user/payment_methods/{payment_method_id}`;
        urlPath = urlPath.replace(`{${"payment_method_id"}}`, encodeURIComponent(String(requestParameters['paymentMethodId'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SuccessResponseFromJSON(jsonValue));
    }

    /**
     * Delete a payment method.
     */
    async userPaymentMethodsPaymentMethodIdDelete(requestParameters: UserPaymentMethodsPaymentMethodIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SuccessResponse> {
        const response = await this.userPaymentMethodsPaymentMethodIdDeleteRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get a payment method.
     */
    async userPaymentMethodsPaymentMethodIdGetRaw(requestParameters: UserPaymentMethodsPaymentMethodIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PaymentMethod>> {
        if (requestParameters['paymentMethodId'] == null) {
            throw new runtime.RequiredError(
                'paymentMethodId',
                'Required parameter "paymentMethodId" was null or undefined when calling userPaymentMethodsPaymentMethodIdGet().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['test'] != null) {
            queryParameters['test'] = requestParameters['test'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2PasswordBearer", []);
        }


        let urlPath = `/user/payment_methods/{payment_method_id}`;
        urlPath = urlPath.replace(`{${"payment_method_id"}}`, encodeURIComponent(String(requestParameters['paymentMethodId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaymentMethodFromJSON(jsonValue));
    }

    /**
     * Get a payment method.
     */
    async userPaymentMethodsPaymentMethodIdGet(requestParameters: UserPaymentMethodsPaymentMethodIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PaymentMethod> {
        const response = await this.userPaymentMethodsPaymentMethodIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create a payment method.
     */
    async userPaymentMethodsPostRaw(requestParameters: UserPaymentMethodsPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PaymentMethod>> {
        if (requestParameters['paymentMethod'] == null) {
            throw new runtime.RequiredError(
                'paymentMethod',
                'Required parameter "paymentMethod" was null or undefined when calling userPaymentMethodsPost().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['test'] != null) {
            queryParameters['test'] = requestParameters['test'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2PasswordBearer", []);
        }


        let urlPath = `/user/payment_methods`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: PaymentMethodToJSON(requestParameters['paymentMethod']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaymentMethodFromJSON(jsonValue));
    }

    /**
     * Create a payment method.
     */
    async userPaymentMethodsPost(requestParameters: UserPaymentMethodsPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PaymentMethod> {
        const response = await this.userPaymentMethodsPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create user manually outside of next auth flow
     */
    async userPostRaw(requestParameters: UserPostOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<User>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2PasswordBearer", []);
        }


        let urlPath = `/user`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: UserPostRequestToJSON(requestParameters['userPostRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UserFromJSON(jsonValue));
    }

    /**
     * Create user manually outside of next auth flow
     */
    async userPost(requestParameters: UserPostOperationRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<User> {
        const response = await this.userPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update User Status
     */
    async userPutRaw(requestParameters: UserPutOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<User>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2PasswordBearer", []);
        }


        let urlPath = `/user`;

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UserPutRequestToJSON(requestParameters['userPutRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UserFromJSON(jsonValue));
    }

    /**
     * Update User Status
     */
    async userPut(requestParameters: UserPutOperationRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<User> {
        const response = await this.userPutRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * List saved search filter presets for the authenticated user.
     */
    async userSearchPresetsGetRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SearchPresetsResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2PasswordBearer", []);
        }


        let urlPath = `/user/search-presets`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SearchPresetsResponseFromJSON(jsonValue));
    }

    /**
     * List saved search filter presets for the authenticated user.
     */
    async userSearchPresetsGet(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SearchPresetsResponse> {
        const response = await this.userSearchPresetsGetRaw(initOverrides);
        return await response.value();
    }

    /**
     * Create a saved search filter preset.
     */
    async userSearchPresetsPostRaw(requestParameters: UserSearchPresetsPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SearchPreset>> {
        if (requestParameters['createSearchPresetRequest'] == null) {
            throw new runtime.RequiredError(
                'createSearchPresetRequest',
                'Required parameter "createSearchPresetRequest" was null or undefined when calling userSearchPresetsPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2PasswordBearer", []);
        }


        let urlPath = `/user/search-presets`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateSearchPresetRequestToJSON(requestParameters['createSearchPresetRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SearchPresetFromJSON(jsonValue));
    }

    /**
     * Create a saved search filter preset.
     */
    async userSearchPresetsPost(requestParameters: UserSearchPresetsPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SearchPreset> {
        const response = await this.userSearchPresetsPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Delete a saved search filter preset.
     */
    async userSearchPresetsPresetIdDeleteRaw(requestParameters: UserSearchPresetsPresetIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['presetId'] == null) {
            throw new runtime.RequiredError(
                'presetId',
                'Required parameter "presetId" was null or undefined when calling userSearchPresetsPresetIdDelete().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2PasswordBearer", []);
        }


        let urlPath = `/user/search-presets/{preset_id}`;
        urlPath = urlPath.replace(`{${"preset_id"}}`, encodeURIComponent(String(requestParameters['presetId'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete a saved search filter preset.
     */
    async userSearchPresetsPresetIdDelete(requestParameters: UserSearchPresetsPresetIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.userSearchPresetsPresetIdDeleteRaw(requestParameters, initOverrides);
    }

    /**
     * Get details of the user\'s active status challenge.
     */
    async userStatusChallengeGetRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ActiveStatusChallengeResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2PasswordBearer", []);
        }


        let urlPath = `/user/status_challenge`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ActiveStatusChallengeResponseFromJSON(jsonValue));
    }

    /**
     * Get details of the user\'s active status challenge.
     */
    async userStatusChallengeGet(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ActiveStatusChallengeResponse> {
        const response = await this.userStatusChallengeGetRaw(initOverrides);
        return await response.value();
    }

    /**
     * Update user status challenge.
     */
    async userStatusChallengePostRaw(requestParameters: UserStatusChallengePostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<StatusChallengeResponse>> {
        if (requestParameters['statusChallengeRequest'] == null) {
            throw new runtime.RequiredError(
                'statusChallengeRequest',
                'Required parameter "statusChallengeRequest" was null or undefined when calling userStatusChallengePost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2PasswordBearer", []);
        }


        let urlPath = `/user/status_challenge`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: StatusChallengeRequestToJSON(requestParameters['statusChallengeRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => StatusChallengeResponseFromJSON(jsonValue));
    }

    /**
     * Update user status challenge.
     */
    async userStatusChallengePost(requestParameters: UserStatusChallengePostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<StatusChallengeResponse> {
        const response = await this.userStatusChallengePostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async userStatusMatchGetRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<StatusMatchResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2PasswordBearer", []);
        }


        let urlPath = `/user/status_match`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => StatusMatchResponseFromJSON(jsonValue));
    }

    /**
     */
    async userStatusMatchGet(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<StatusMatchResponse> {
        const response = await this.userStatusMatchGetRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async userStatusMatchPostRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<StatusMatchResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2PasswordBearer", []);
        }


        let urlPath = `/user/status_match`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => StatusMatchResponseFromJSON(jsonValue));
    }

    /**
     */
    async userStatusMatchPost(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<StatusMatchResponse> {
        const response = await this.userStatusMatchPostRaw(initOverrides);
        return await response.value();
    }

    /**
     * Get a user\'s travel history.
     */
    async userTravelHistoryGetRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TravelHistoryResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2PasswordBearer", []);
        }


        let urlPath = `/user/travel_history`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TravelHistoryResponseFromJSON(jsonValue));
    }

    /**
     * Get a user\'s travel history.
     */
    async userTravelHistoryGet(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TravelHistoryResponse> {
        const response = await this.userTravelHistoryGetRaw(initOverrides);
        return await response.value();
    }

    /**
     * Get a user\'s travel profiles.
     */
    async userTravelProfilesGetRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TravelProfileResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2PasswordBearer", []);
        }


        let urlPath = `/user/travel_profiles`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TravelProfileResponseFromJSON(jsonValue));
    }

    /**
     * Get a user\'s travel profiles.
     */
    async userTravelProfilesGet(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TravelProfileResponse> {
        const response = await this.userTravelProfilesGetRaw(initOverrides);
        return await response.value();
    }

    /**
     * Create a travel profile.
     */
    async userTravelProfilesPostRaw(requestParameters: UserTravelProfilesPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TravelProfile>> {
        if (requestParameters['travelProfile'] == null) {
            throw new runtime.RequiredError(
                'travelProfile',
                'Required parameter "travelProfile" was null or undefined when calling userTravelProfilesPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2PasswordBearer", []);
        }


        let urlPath = `/user/travel_profiles`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: TravelProfileToJSON(requestParameters['travelProfile']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TravelProfileFromJSON(jsonValue));
    }

    /**
     * Create a travel profile.
     */
    async userTravelProfilesPost(requestParameters: UserTravelProfilesPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TravelProfile> {
        const response = await this.userTravelProfilesPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Delete a travel profile.
     */
    async userTravelProfilesTravelProfileIdDeleteRaw(requestParameters: UserTravelProfilesTravelProfileIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SuccessResponse>> {
        if (requestParameters['travelProfileId'] == null) {
            throw new runtime.RequiredError(
                'travelProfileId',
                'Required parameter "travelProfileId" was null or undefined when calling userTravelProfilesTravelProfileIdDelete().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2PasswordBearer", []);
        }


        let urlPath = `/user/travel_profiles/{travel_profile_id}`;
        urlPath = urlPath.replace(`{${"travel_profile_id"}}`, encodeURIComponent(String(requestParameters['travelProfileId'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SuccessResponseFromJSON(jsonValue));
    }

    /**
     * Delete a travel profile.
     */
    async userTravelProfilesTravelProfileIdDelete(requestParameters: UserTravelProfilesTravelProfileIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SuccessResponse> {
        const response = await this.userTravelProfilesTravelProfileIdDeleteRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get a travel profile.
     */
    async userTravelProfilesTravelProfileIdGetRaw(requestParameters: UserTravelProfilesTravelProfileIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TravelProfile>> {
        if (requestParameters['travelProfileId'] == null) {
            throw new runtime.RequiredError(
                'travelProfileId',
                'Required parameter "travelProfileId" was null or undefined when calling userTravelProfilesTravelProfileIdGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2PasswordBearer", []);
        }


        let urlPath = `/user/travel_profiles/{travel_profile_id}`;
        urlPath = urlPath.replace(`{${"travel_profile_id"}}`, encodeURIComponent(String(requestParameters['travelProfileId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TravelProfileFromJSON(jsonValue));
    }

    /**
     * Get a travel profile.
     */
    async userTravelProfilesTravelProfileIdGet(requestParameters: UserTravelProfilesTravelProfileIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TravelProfile> {
        const response = await this.userTravelProfilesTravelProfileIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update a travel profile.
     */
    async userTravelProfilesTravelProfileIdPutRaw(requestParameters: UserTravelProfilesTravelProfileIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TravelProfile>> {
        if (requestParameters['travelProfileId'] == null) {
            throw new runtime.RequiredError(
                'travelProfileId',
                'Required parameter "travelProfileId" was null or undefined when calling userTravelProfilesTravelProfileIdPut().'
            );
        }

        if (requestParameters['travelProfile'] == null) {
            throw new runtime.RequiredError(
                'travelProfile',
                'Required parameter "travelProfile" was null or undefined when calling userTravelProfilesTravelProfileIdPut().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2PasswordBearer", []);
        }


        let urlPath = `/user/travel_profiles/{travel_profile_id}`;
        urlPath = urlPath.replace(`{${"travel_profile_id"}}`, encodeURIComponent(String(requestParameters['travelProfileId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: TravelProfileToJSON(requestParameters['travelProfile']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TravelProfileFromJSON(jsonValue));
    }

    /**
     * Update a travel profile.
     */
    async userTravelProfilesTravelProfileIdPut(requestParameters: UserTravelProfilesTravelProfileIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TravelProfile> {
        const response = await this.userTravelProfilesTravelProfileIdPutRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get a user\'s trips.
     */
    async userTripsGetRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Trips>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2PasswordBearer", []);
        }


        let urlPath = `/user/trips`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TripsFromJSON(jsonValue));
    }

    /**
     * Get a user\'s trips.
     */
    async userTripsGet(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Trips> {
        const response = await this.userTripsGetRaw(initOverrides);
        return await response.value();
    }

    /**
     * Mark a hotel trip as cancelled.
     */
    async userTripsHotelsBookingsBookingIdPutRaw(requestParameters: UserTripsHotelsBookingsBookingIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Hotel>> {
        if (requestParameters['bookingId'] == null) {
            throw new runtime.RequiredError(
                'bookingId',
                'Required parameter "bookingId" was null or undefined when calling userTripsHotelsBookingsBookingIdPut().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2PasswordBearer", []);
        }


        let urlPath = `/user/trips/hotels/bookings/{booking_id}`;
        urlPath = urlPath.replace(`{${"booking_id"}}`, encodeURIComponent(String(requestParameters['bookingId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => HotelFromJSON(jsonValue));
    }

    /**
     * Mark a hotel trip as cancelled.
     */
    async userTripsHotelsBookingsBookingIdPut(requestParameters: UserTripsHotelsBookingsBookingIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Hotel> {
        const response = await this.userTripsHotelsBookingsBookingIdPutRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create a trip.
     */
    async userTripsPostRaw(requestParameters: UserTripsPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Trip>> {
        if (requestParameters['trip'] == null) {
            throw new runtime.RequiredError(
                'trip',
                'Required parameter "trip" was null or undefined when calling userTripsPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2PasswordBearer", []);
        }


        let urlPath = `/user/trips`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: TripToJSON(requestParameters['trip']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TripFromJSON(jsonValue));
    }

    /**
     * Create a trip.
     */
    async userTripsPost(requestParameters: UserTripsPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Trip> {
        const response = await this.userTripsPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Sync user trips.
     */
    async userTripsSyncPostRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Trips>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2PasswordBearer", []);
        }


        let urlPath = `/user/trips/sync`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TripsFromJSON(jsonValue));
    }

    /**
     * Sync user trips.
     */
    async userTripsSyncPost(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Trips> {
        const response = await this.userTripsSyncPostRaw(initOverrides);
        return await response.value();
    }

    /**
     * Soft-delete a manually-added or email-parsed vehicle rental.
     */
    async userTripsVehiclesDeleteRaw(requestParameters: UserTripsVehiclesDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SuccessResponse>> {
        if (requestParameters['vehicleRentalDeleteRequest'] == null) {
            throw new runtime.RequiredError(
                'vehicleRentalDeleteRequest',
                'Required parameter "vehicleRentalDeleteRequest" was null or undefined when calling userTripsVehiclesDelete().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2PasswordBearer", []);
        }


        let urlPath = `/user/trips/vehicles`;

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
            body: VehicleRentalDeleteRequestToJSON(requestParameters['vehicleRentalDeleteRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SuccessResponseFromJSON(jsonValue));
    }

    /**
     * Soft-delete a manually-added or email-parsed vehicle rental.
     */
    async userTripsVehiclesDelete(requestParameters: UserTripsVehiclesDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SuccessResponse> {
        const response = await this.userTripsVehiclesDeleteRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Mark a vehicle rental as cancelled.
     */
    async userTripsVehiclesGondolaBookingIdCancelPutRaw(requestParameters: UserTripsVehiclesGondolaBookingIdCancelPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<VehicleRental>> {
        if (requestParameters['gondolaBookingId'] == null) {
            throw new runtime.RequiredError(
                'gondolaBookingId',
                'Required parameter "gondolaBookingId" was null or undefined when calling userTripsVehiclesGondolaBookingIdCancelPut().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2PasswordBearer", []);
        }


        let urlPath = `/user/trips/vehicles/{gondola_booking_id}/cancel`;
        urlPath = urlPath.replace(`{${"gondola_booking_id"}}`, encodeURIComponent(String(requestParameters['gondolaBookingId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => VehicleRentalFromJSON(jsonValue));
    }

    /**
     * Mark a vehicle rental as cancelled.
     */
    async userTripsVehiclesGondolaBookingIdCancelPut(requestParameters: UserTripsVehiclesGondolaBookingIdCancelPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<VehicleRental> {
        const response = await this.userTripsVehiclesGondolaBookingIdCancelPutRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create a vehicle rental trip record.
     */
    async userTripsVehiclesPostRaw(requestParameters: UserTripsVehiclesPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<VehicleRental>> {
        if (requestParameters['vehicleRentalRequest'] == null) {
            throw new runtime.RequiredError(
                'vehicleRentalRequest',
                'Required parameter "vehicleRentalRequest" was null or undefined when calling userTripsVehiclesPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2PasswordBearer", []);
        }


        let urlPath = `/user/trips/vehicles`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: VehicleRentalRequestToJSON(requestParameters['vehicleRentalRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => VehicleRentalFromJSON(jsonValue));
    }

    /**
     * Create a vehicle rental trip record.
     */
    async userTripsVehiclesPost(requestParameters: UserTripsVehiclesPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<VehicleRental> {
        const response = await this.userTripsVehiclesPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update a vehicle rental (e.g. toggle auto_save).
     */
    async userTripsVehiclesPutRaw(requestParameters: UserTripsVehiclesPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<VehicleRental>> {
        if (requestParameters['vehicleRentalRequest'] == null) {
            throw new runtime.RequiredError(
                'vehicleRentalRequest',
                'Required parameter "vehicleRentalRequest" was null or undefined when calling userTripsVehiclesPut().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2PasswordBearer", []);
        }


        let urlPath = `/user/trips/vehicles`;

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: VehicleRentalRequestToJSON(requestParameters['vehicleRentalRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => VehicleRentalFromJSON(jsonValue));
    }

    /**
     * Update a vehicle rental (e.g. toggle auto_save).
     */
    async userTripsVehiclesPut(requestParameters: UserTripsVehiclesPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<VehicleRental> {
        const response = await this.userTripsVehiclesPutRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create an AwardWallet connection URL.
     */
    async usersAwardwalletAuthUrlsPostRaw(requestParameters: UsersAwardwalletAuthUrlsPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AwardWalletAuthUrlResponse>> {
        if (requestParameters['awardWalletAuthUrlRequest'] == null) {
            throw new runtime.RequiredError(
                'awardWalletAuthUrlRequest',
                'Required parameter "awardWalletAuthUrlRequest" was null or undefined when calling usersAwardwalletAuthUrlsPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2PasswordBearer", []);
        }


        let urlPath = `/users/awardwallet/auth_urls`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AwardWalletAuthUrlRequestToJSON(requestParameters['awardWalletAuthUrlRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AwardWalletAuthUrlResponseFromJSON(jsonValue));
    }

    /**
     * Create an AwardWallet connection URL.
     */
    async usersAwardwalletAuthUrlsPost(requestParameters: UsersAwardwalletAuthUrlsPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AwardWalletAuthUrlResponse> {
        const response = await this.usersAwardwalletAuthUrlsPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Handle AwardWallet callback and redirect back to Gondola.
     */
    async usersAwardwalletCallbackGetRaw(requestParameters: UsersAwardwalletCallbackGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['code'] == null) {
            throw new runtime.RequiredError(
                'code',
                'Required parameter "code" was null or undefined when calling usersAwardwalletCallbackGet().'
            );
        }

        if (requestParameters['state'] == null) {
            throw new runtime.RequiredError(
                'state',
                'Required parameter "state" was null or undefined when calling usersAwardwalletCallbackGet().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['code'] != null) {
            queryParameters['code'] = requestParameters['code'];
        }

        if (requestParameters['state'] != null) {
            queryParameters['state'] = requestParameters['state'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/users/awardwallet/callback`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Handle AwardWallet callback and redirect back to Gondola.
     */
    async usersAwardwalletCallbackGet(requestParameters: UsersAwardwalletCallbackGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.usersAwardwalletCallbackGetRaw(requestParameters, initOverrides);
    }

    /**
     * Disconnect the authenticated user\'s AwardWallet connection.
     */
    async usersAwardwalletConnectionDeleteRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2PasswordBearer", []);
        }


        let urlPath = `/users/awardwallet/connection`;

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Disconnect the authenticated user\'s AwardWallet connection.
     */
    async usersAwardwalletConnectionDelete(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.usersAwardwalletConnectionDeleteRaw(initOverrides);
    }

    /**
     * Return the authenticated user\'s AwardWallet connection status.
     */
    async usersAwardwalletConnectionGetRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AwardWalletConnectionInfoResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2PasswordBearer", []);
        }


        let urlPath = `/users/awardwallet/connection`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AwardWalletConnectionInfoResponseFromJSON(jsonValue));
    }

    /**
     * Return the authenticated user\'s AwardWallet connection status.
     */
    async usersAwardwalletConnectionGet(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AwardWalletConnectionInfoResponse> {
        const response = await this.usersAwardwalletConnectionGetRaw(initOverrides);
        return await response.value();
    }

    /**
     * Trigger an AwardWallet account sync for the authenticated user.
     */
    async usersAwardwalletSyncPostRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AwardWalletSyncResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2PasswordBearer", []);
        }


        let urlPath = `/users/awardwallet/sync`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AwardWalletSyncResponseFromJSON(jsonValue));
    }

    /**
     * Trigger an AwardWallet account sync for the authenticated user.
     */
    async usersAwardwalletSyncPost(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AwardWalletSyncResponse> {
        const response = await this.usersAwardwalletSyncPostRaw(initOverrides);
        return await response.value();
    }

    /**
     * Given a booking, apply all available credits, e.g. gives credit to the referring user for the booking made, give a 3% cashback credit to the user making the booking, etc.
     */
    async usersCreditsBookingsBookingIdPostRaw(requestParameters: UsersCreditsBookingsBookingIdPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UserBookingCredits>> {
        if (requestParameters['bookingId'] == null) {
            throw new runtime.RequiredError(
                'bookingId',
                'Required parameter "bookingId" was null or undefined when calling usersCreditsBookingsBookingIdPost().'
            );
        }

        if (requestParameters['applyBookingCreditsRequest'] == null) {
            throw new runtime.RequiredError(
                'applyBookingCreditsRequest',
                'Required parameter "applyBookingCreditsRequest" was null or undefined when calling usersCreditsBookingsBookingIdPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2PasswordBearer", []);
        }


        let urlPath = `/users/credits/bookings/{booking_id}`;
        urlPath = urlPath.replace(`{${"booking_id"}}`, encodeURIComponent(String(requestParameters['bookingId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ApplyBookingCreditsRequestToJSON(requestParameters['applyBookingCreditsRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UserBookingCreditsFromJSON(jsonValue));
    }

    /**
     * Given a booking, apply all available credits, e.g. gives credit to the referring user for the booking made, give a 3% cashback credit to the user making the booking, etc.
     */
    async usersCreditsBookingsBookingIdPost(requestParameters: UsersCreditsBookingsBookingIdPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UserBookingCredits> {
        const response = await this.usersCreditsBookingsBookingIdPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Adjust credits by the specified amount.
     */
    async usersCreditsBookingsBookingIdPutRaw(requestParameters: UsersCreditsBookingsBookingIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UserBookingCredits>> {
        if (requestParameters['bookingId'] == null) {
            throw new runtime.RequiredError(
                'bookingId',
                'Required parameter "bookingId" was null or undefined when calling usersCreditsBookingsBookingIdPut().'
            );
        }

        if (requestParameters['adjustCreditRequest'] == null) {
            throw new runtime.RequiredError(
                'adjustCreditRequest',
                'Required parameter "adjustCreditRequest" was null or undefined when calling usersCreditsBookingsBookingIdPut().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2PasswordBearer", []);
        }


        let urlPath = `/users/credits/bookings/{booking_id}`;
        urlPath = urlPath.replace(`{${"booking_id"}}`, encodeURIComponent(String(requestParameters['bookingId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: AdjustCreditRequestToJSON(requestParameters['adjustCreditRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UserBookingCreditsFromJSON(jsonValue));
    }

    /**
     * Adjust credits by the specified amount.
     */
    async usersCreditsBookingsBookingIdPut(requestParameters: UsersCreditsBookingsBookingIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UserBookingCredits> {
        const response = await this.usersCreditsBookingsBookingIdPutRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Recompute cashback credits for a booking after a price change (e.g. member rate accepted during checkout). Deletes existing cashback ledger entries and re-applies with the new commissionable cost.
     */
    async usersCreditsBookingsBookingIdRecomputePostRaw(requestParameters: UsersCreditsBookingsBookingIdRecomputePostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UserBookingCredits>> {
        if (requestParameters['bookingId'] == null) {
            throw new runtime.RequiredError(
                'bookingId',
                'Required parameter "bookingId" was null or undefined when calling usersCreditsBookingsBookingIdRecomputePost().'
            );
        }

        if (requestParameters['recomputeBookingCreditsRequest'] == null) {
            throw new runtime.RequiredError(
                'recomputeBookingCreditsRequest',
                'Required parameter "recomputeBookingCreditsRequest" was null or undefined when calling usersCreditsBookingsBookingIdRecomputePost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2PasswordBearer", []);
        }


        let urlPath = `/users/credits/bookings/{booking_id}/recompute`;
        urlPath = urlPath.replace(`{${"booking_id"}}`, encodeURIComponent(String(requestParameters['bookingId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RecomputeBookingCreditsRequestToJSON(requestParameters['recomputeBookingCreditsRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UserBookingCreditsFromJSON(jsonValue));
    }

    /**
     * Recompute cashback credits for a booking after a price change (e.g. member rate accepted during checkout). Deletes existing cashback ledger entries and re-applies with the new commissionable cost.
     */
    async usersCreditsBookingsBookingIdRecomputePost(requestParameters: UsersCreditsBookingsBookingIdRecomputePostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UserBookingCredits> {
        const response = await this.usersCreditsBookingsBookingIdRecomputePostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get all user credit information
     */
    async usersCreditsGetRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UserCredits>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2PasswordBearer", []);
        }


        let urlPath = `/users/credits`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UserCreditsFromJSON(jsonValue));
    }

    /**
     * Get all user credit information
     */
    async usersCreditsGet(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UserCredits> {
        const response = await this.usersCreditsGetRaw(initOverrides);
        return await response.value();
    }

    /**
     * Check if we can send an email.
     */
    async usersEmailsCanSendPostRaw(requestParameters: UsersEmailsCanSendPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CanSendEmailResponse>> {
        if (requestParameters['canSendEmailRequest'] == null) {
            throw new runtime.RequiredError(
                'canSendEmailRequest',
                'Required parameter "canSendEmailRequest" was null or undefined when calling usersEmailsCanSendPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2PasswordBearer", []);
        }


        let urlPath = `/users/emails/can_send`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CanSendEmailRequestToJSON(requestParameters['canSendEmailRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CanSendEmailResponseFromJSON(jsonValue));
    }

    /**
     * Check if we can send an email.
     */
    async usersEmailsCanSendPost(requestParameters: UsersEmailsCanSendPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CanSendEmailResponse> {
        const response = await this.usersEmailsCanSendPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Record an email sent.
     */
    async usersEmailsPostRaw(requestParameters: UsersEmailsPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Email>> {
        if (requestParameters['recordEmailSentRequest'] == null) {
            throw new runtime.RequiredError(
                'recordEmailSentRequest',
                'Required parameter "recordEmailSentRequest" was null or undefined when calling usersEmailsPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2PasswordBearer", []);
        }


        let urlPath = `/users/emails`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RecordEmailSentRequestToJSON(requestParameters['recordEmailSentRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => EmailFromJSON(jsonValue));
    }

    /**
     * Record an email sent.
     */
    async usersEmailsPost(requestParameters: UsersEmailsPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Email> {
        const response = await this.usersEmailsPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Gondola mapped.
     */
    async usersGondolaMappedYearYearGetRaw(requestParameters: UsersGondolaMappedYearYearGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GondolaMappedResponse>> {
        if (requestParameters['year'] == null) {
            throw new runtime.RequiredError(
                'year',
                'Required parameter "year" was null or undefined when calling usersGondolaMappedYearYearGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2PasswordBearer", []);
        }


        let urlPath = `/users/gondola_mapped/year/{year}`;
        urlPath = urlPath.replace(`{${"year"}}`, encodeURIComponent(String(requestParameters['year'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GondolaMappedResponseFromJSON(jsonValue));
    }

    /**
     * Gondola mapped.
     */
    async usersGondolaMappedYearYearGet(requestParameters: UsersGondolaMappedYearYearGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GondolaMappedResponse> {
        const response = await this.usersGondolaMappedYearYearGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Links the authenticated user to a pending invite token after verifying the invite email matches the user\'s email.
     */
    async usersInvitesLinkPostRaw(requestParameters: UsersInvitesLinkPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SuccessResponse>> {
        if (requestParameters['inviteLinkRequest'] == null) {
            throw new runtime.RequiredError(
                'inviteLinkRequest',
                'Required parameter "inviteLinkRequest" was null or undefined when calling usersInvitesLinkPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2PasswordBearer", []);
        }


        let urlPath = `/users/invites/link`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: InviteLinkRequestToJSON(requestParameters['inviteLinkRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SuccessResponseFromJSON(jsonValue));
    }

    /**
     * Links the authenticated user to a pending invite token after verifying the invite email matches the user\'s email.
     */
    async usersInvitesLinkPost(requestParameters: UsersInvitesLinkPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SuccessResponse> {
        const response = await this.usersInvitesLinkPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Initializes the user\'s referral code and optionally set that user\'s referred-by field.
     */
    async usersInvitesPostRaw(requestParameters: UsersInvitesPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Referral>> {
        if (requestParameters['referralsRequest'] == null) {
            throw new runtime.RequiredError(
                'referralsRequest',
                'Required parameter "referralsRequest" was null or undefined when calling usersInvitesPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2PasswordBearer", []);
        }


        let urlPath = `/users/invites`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ReferralsRequestToJSON(requestParameters['referralsRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ReferralFromJSON(jsonValue));
    }

    /**
     * Initializes the user\'s referral code and optionally set that user\'s referred-by field.
     */
    async usersInvitesPost(requestParameters: UsersInvitesPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Referral> {
        const response = await this.usersInvitesPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create an MX connect-widget URL.
     */
    async usersMxConnectWidgetUrlsPostRaw(requestParameters: UsersMxConnectWidgetUrlsPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MxConnectWidgetUrlResponse>> {
        if (requestParameters['mxConnectWidgetUrlRequest'] == null) {
            throw new runtime.RequiredError(
                'mxConnectWidgetUrlRequest',
                'Required parameter "mxConnectWidgetUrlRequest" was null or undefined when calling usersMxConnectWidgetUrlsPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2PasswordBearer", []);
        }


        let urlPath = `/users/mx/connect_widget_urls`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: MxConnectWidgetUrlRequestToJSON(requestParameters['mxConnectWidgetUrlRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MxConnectWidgetUrlResponseFromJSON(jsonValue));
    }

    /**
     * Create an MX connect-widget URL.
     */
    async usersMxConnectWidgetUrlsPost(requestParameters: UsersMxConnectWidgetUrlsPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MxConnectWidgetUrlResponse> {
        const response = await this.usersMxConnectWidgetUrlsPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Delete an MX reward entry.
     */
    async usersMxRewardsMxRewardIdDeleteRaw(requestParameters: UsersMxRewardsMxRewardIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['mxRewardId'] == null) {
            throw new runtime.RequiredError(
                'mxRewardId',
                'Required parameter "mxRewardId" was null or undefined when calling usersMxRewardsMxRewardIdDelete().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2PasswordBearer", []);
        }


        let urlPath = `/users/mx_rewards/{mx_reward_id}`;
        urlPath = urlPath.replace(`{${"mx_reward_id"}}`, encodeURIComponent(String(requestParameters['mxRewardId'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete an MX reward entry.
     */
    async usersMxRewardsMxRewardIdDelete(requestParameters: UsersMxRewardsMxRewardIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.usersMxRewardsMxRewardIdDeleteRaw(requestParameters, initOverrides);
    }

    /**
     * Update an MX reward entry
     */
    async usersMxRewardsMxRewardIdPutRaw(requestParameters: UsersMxRewardsMxRewardIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MxReward>> {
        if (requestParameters['mxRewardId'] == null) {
            throw new runtime.RequiredError(
                'mxRewardId',
                'Required parameter "mxRewardId" was null or undefined when calling usersMxRewardsMxRewardIdPut().'
            );
        }

        if (requestParameters['mxRewardUpdateRequest'] == null) {
            throw new runtime.RequiredError(
                'mxRewardUpdateRequest',
                'Required parameter "mxRewardUpdateRequest" was null or undefined when calling usersMxRewardsMxRewardIdPut().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2PasswordBearer", []);
        }


        let urlPath = `/users/mx_rewards/{mx_reward_id}`;
        urlPath = urlPath.replace(`{${"mx_reward_id"}}`, encodeURIComponent(String(requestParameters['mxRewardId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: MxRewardUpdateRequestToJSON(requestParameters['mxRewardUpdateRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MxRewardFromJSON(jsonValue));
    }

    /**
     * Update an MX reward entry
     */
    async usersMxRewardsMxRewardIdPut(requestParameters: UsersMxRewardsMxRewardIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MxReward> {
        const response = await this.usersMxRewardsMxRewardIdPutRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Manually add a recognized credit card without connecting MX.
     */
    async usersMxRewardsPostRaw(requestParameters: UsersMxRewardsPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MxReward>> {
        if (requestParameters['manualMxRewardCreateRequest'] == null) {
            throw new runtime.RequiredError(
                'manualMxRewardCreateRequest',
                'Required parameter "manualMxRewardCreateRequest" was null or undefined when calling usersMxRewardsPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2PasswordBearer", []);
        }


        let urlPath = `/users/mx_rewards`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ManualMxRewardCreateRequestToJSON(requestParameters['manualMxRewardCreateRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MxRewardFromJSON(jsonValue));
    }

    /**
     * Manually add a recognized credit card without connecting MX.
     */
    async usersMxRewardsPost(requestParameters: UsersMxRewardsPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MxReward> {
        const response = await this.usersMxRewardsPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get all MX rewards entries.
     */
    async usersMxRewardsRewardsProgramsNameGetRaw(requestParameters: UsersMxRewardsRewardsProgramsNameGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MxRewards>> {
        if (requestParameters['name'] == null) {
            throw new runtime.RequiredError(
                'name',
                'Required parameter "name" was null or undefined when calling usersMxRewardsRewardsProgramsNameGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2PasswordBearer", []);
        }


        let urlPath = `/users/mx_rewards/rewards_programs/{name}`;
        urlPath = urlPath.replace(`{${"name"}}`, encodeURIComponent(String(requestParameters['name'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MxRewardsFromJSON(jsonValue));
    }

    /**
     * Get all MX rewards entries.
     */
    async usersMxRewardsRewardsProgramsNameGet(requestParameters: UsersMxRewardsRewardsProgramsNameGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MxRewards> {
        const response = await this.usersMxRewardsRewardsProgramsNameGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Immediately check if a sync happened or not.
     */
    async usersMxSyncPostRaw(requestParameters: UsersMxSyncPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['mxSyncRequest'] == null) {
            throw new runtime.RequiredError(
                'mxSyncRequest',
                'Required parameter "mxSyncRequest" was null or undefined when calling usersMxSyncPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2PasswordBearer", []);
        }


        let urlPath = `/users/mx/sync`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: MxSyncRequestToJSON(requestParameters['mxSyncRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Immediately check if a sync happened or not.
     */
    async usersMxSyncPost(requestParameters: UsersMxSyncPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.usersMxSyncPostRaw(requestParameters, initOverrides);
    }

    /**
     * Unsubscribe users from emails
     */
    async usersSubscriptionsPutRaw(requestParameters: UsersSubscriptionsPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['subscriptionRequest'] == null) {
            throw new runtime.RequiredError(
                'subscriptionRequest',
                'Required parameter "subscriptionRequest" was null or undefined when calling usersSubscriptionsPut().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2PasswordBearer", []);
        }


        let urlPath = `/users/subscriptions`;

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: SubscriptionRequestToJSON(requestParameters['subscriptionRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Unsubscribe users from emails
     */
    async usersSubscriptionsPut(requestParameters: UsersSubscriptionsPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.usersSubscriptionsPutRaw(requestParameters, initOverrides);
    }

    /**
     * Delete linked google-scoped-auth account.
     */
    async usersUserIdAccountsAccountIdDeleteRaw(requestParameters: UsersUserIdAccountsAccountIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Account>> {
        if (requestParameters['userId'] == null) {
            throw new runtime.RequiredError(
                'userId',
                'Required parameter "userId" was null or undefined when calling usersUserIdAccountsAccountIdDelete().'
            );
        }

        if (requestParameters['accountId'] == null) {
            throw new runtime.RequiredError(
                'accountId',
                'Required parameter "accountId" was null or undefined when calling usersUserIdAccountsAccountIdDelete().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2PasswordBearer", []);
        }


        let urlPath = `/users/{user_id}/accounts/{account_id}`;
        urlPath = urlPath.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters['userId'])));
        urlPath = urlPath.replace(`{${"account_id"}}`, encodeURIComponent(String(requestParameters['accountId'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AccountFromJSON(jsonValue));
    }

    /**
     * Delete linked google-scoped-auth account.
     */
    async usersUserIdAccountsAccountIdDelete(requestParameters: UsersUserIdAccountsAccountIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Account> {
        const response = await this.usersUserIdAccountsAccountIdDeleteRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Rate a user\'s past stay.
     */
    async usersUserIdBookingsBookingIdRatePastStayPutRaw(requestParameters: UsersUserIdBookingsBookingIdRatePastStayPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['userId'] == null) {
            throw new runtime.RequiredError(
                'userId',
                'Required parameter "userId" was null or undefined when calling usersUserIdBookingsBookingIdRatePastStayPut().'
            );
        }

        if (requestParameters['bookingId'] == null) {
            throw new runtime.RequiredError(
                'bookingId',
                'Required parameter "bookingId" was null or undefined when calling usersUserIdBookingsBookingIdRatePastStayPut().'
            );
        }

        if (requestParameters['ratePastStayRequest'] == null) {
            throw new runtime.RequiredError(
                'ratePastStayRequest',
                'Required parameter "ratePastStayRequest" was null or undefined when calling usersUserIdBookingsBookingIdRatePastStayPut().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2PasswordBearer", []);
        }


        let urlPath = `/users/{user_id}/bookings/{booking_id}/rate_past_stay`;
        urlPath = urlPath.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters['userId'])));
        urlPath = urlPath.replace(`{${"booking_id"}}`, encodeURIComponent(String(requestParameters['bookingId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: RatePastStayRequestToJSON(requestParameters['ratePastStayRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Rate a user\'s past stay.
     */
    async usersUserIdBookingsBookingIdRatePastStayPut(requestParameters: UsersUserIdBookingsBookingIdRatePastStayPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.usersUserIdBookingsBookingIdRatePastStayPutRaw(requestParameters, initOverrides);
    }

    /**
     * Mark a product announcement as read.
     */
    async usersUserIdProductAnnouncementsAnnouncementIdReadPutRaw(requestParameters: UsersUserIdProductAnnouncementsAnnouncementIdReadPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['userId'] == null) {
            throw new runtime.RequiredError(
                'userId',
                'Required parameter "userId" was null or undefined when calling usersUserIdProductAnnouncementsAnnouncementIdReadPut().'
            );
        }

        if (requestParameters['announcementId'] == null) {
            throw new runtime.RequiredError(
                'announcementId',
                'Required parameter "announcementId" was null or undefined when calling usersUserIdProductAnnouncementsAnnouncementIdReadPut().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2PasswordBearer", []);
        }


        let urlPath = `/users/{user_id}/product_announcements/{announcement_id}/read`;
        urlPath = urlPath.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters['userId'])));
        urlPath = urlPath.replace(`{${"announcement_id"}}`, encodeURIComponent(String(requestParameters['announcementId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Mark a product announcement as read.
     */
    async usersUserIdProductAnnouncementsAnnouncementIdReadPut(requestParameters: UsersUserIdProductAnnouncementsAnnouncementIdReadPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.usersUserIdProductAnnouncementsAnnouncementIdReadPutRaw(requestParameters, initOverrides);
    }

    /**
     * Get published product announcements and the user\'s read state.
     */
    async usersUserIdProductAnnouncementsGetRaw(requestParameters: UsersUserIdProductAnnouncementsGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ProductAnnouncements>> {
        if (requestParameters['userId'] == null) {
            throw new runtime.RequiredError(
                'userId',
                'Required parameter "userId" was null or undefined when calling usersUserIdProductAnnouncementsGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2PasswordBearer", []);
        }


        let urlPath = `/users/{user_id}/product_announcements`;
        urlPath = urlPath.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters['userId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ProductAnnouncementsFromJSON(jsonValue));
    }

    /**
     * Get published product announcements and the user\'s read state.
     */
    async usersUserIdProductAnnouncementsGet(requestParameters: UsersUserIdProductAnnouncementsGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ProductAnnouncements> {
        const response = await this.usersUserIdProductAnnouncementsGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get a user\'s welcome actions.
     */
    async usersUserIdWelcomeActionsGetRaw(requestParameters: UsersUserIdWelcomeActionsGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<WelcomeActions>> {
        if (requestParameters['userId'] == null) {
            throw new runtime.RequiredError(
                'userId',
                'Required parameter "userId" was null or undefined when calling usersUserIdWelcomeActionsGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2PasswordBearer", []);
        }


        let urlPath = `/users/{user_id}/welcome_actions`;
        urlPath = urlPath.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters['userId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => WelcomeActionsFromJSON(jsonValue));
    }

    /**
     * Get a user\'s welcome actions.
     */
    async usersUserIdWelcomeActionsGet(requestParameters: UsersUserIdWelcomeActionsGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<WelcomeActions> {
        const response = await this.usersUserIdWelcomeActionsGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Delete a welcome action when it\'s been completed.
     */
    async usersUserIdWelcomeActionsWelcomeActionIdDeleteRaw(requestParameters: UsersUserIdWelcomeActionsWelcomeActionIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['userId'] == null) {
            throw new runtime.RequiredError(
                'userId',
                'Required parameter "userId" was null or undefined when calling usersUserIdWelcomeActionsWelcomeActionIdDelete().'
            );
        }

        if (requestParameters['welcomeActionId'] == null) {
            throw new runtime.RequiredError(
                'welcomeActionId',
                'Required parameter "welcomeActionId" was null or undefined when calling usersUserIdWelcomeActionsWelcomeActionIdDelete().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2PasswordBearer", []);
        }


        let urlPath = `/users/{user_id}/welcome_actions/{welcome_action_id}`;
        urlPath = urlPath.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters['userId'])));
        urlPath = urlPath.replace(`{${"welcome_action_id"}}`, encodeURIComponent(String(requestParameters['welcomeActionId'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete a welcome action when it\'s been completed.
     */
    async usersUserIdWelcomeActionsWelcomeActionIdDelete(requestParameters: UsersUserIdWelcomeActionsWelcomeActionIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.usersUserIdWelcomeActionsWelcomeActionIdDeleteRaw(requestParameters, initOverrides);
    }

    /**
     * List current private offers discovered in the authenticated user\'s inboxes
     */
    async v2UserEmailPromotionsGetRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<EmailPromotionsResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2PasswordBearer", []);
        }


        let urlPath = `/v2/user/email_promotions`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => EmailPromotionsResponseFromJSON(jsonValue));
    }

    /**
     * List current private offers discovered in the authenticated user\'s inboxes
     */
    async v2UserEmailPromotionsGet(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<EmailPromotionsResponse> {
        const response = await this.v2UserEmailPromotionsGetRaw(initOverrides);
        return await response.value();
    }

    /**
     * Clear an owned offer without changing its source email
     */
    async v2UserEmailPromotionsPromotionIdDeleteRaw(requestParameters: V2UserEmailPromotionsPromotionIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['promotionId'] == null) {
            throw new runtime.RequiredError(
                'promotionId',
                'Required parameter "promotionId" was null or undefined when calling v2UserEmailPromotionsPromotionIdDelete().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2PasswordBearer", []);
        }


        let urlPath = `/v2/user/email_promotions/{promotion_id}`;
        urlPath = urlPath.replace(`{${"promotion_id"}}`, encodeURIComponent(String(requestParameters['promotionId'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Clear an owned offer without changing its source email
     */
    async v2UserEmailPromotionsPromotionIdDelete(requestParameters: V2UserEmailPromotionsPromotionIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.v2UserEmailPromotionsPromotionIdDeleteRaw(requestParameters, initOverrides);
    }

    /**
     * Request a bounded scan of the past 90 days of authorized inbox history
     */
    async v2UserEmailPromotionsScanPostRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<EmailPromotionsResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2PasswordBearer", []);
        }


        let urlPath = `/v2/user/email_promotions/scan`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => EmailPromotionsResponseFromJSON(jsonValue));
    }

    /**
     * Request a bounded scan of the past 90 days of authorized inbox history
     */
    async v2UserEmailPromotionsScanPost(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<EmailPromotionsResponse> {
        const response = await this.v2UserEmailPromotionsScanPostRaw(initOverrides);
        return await response.value();
    }

    /**
     * Delete a manually-created flight credit
     */
    async v2UserFlightCreditsCreditIdDeleteRaw(requestParameters: V2UserFlightCreditsCreditIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['creditId'] == null) {
            throw new runtime.RequiredError(
                'creditId',
                'Required parameter "creditId" was null or undefined when calling v2UserFlightCreditsCreditIdDelete().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2PasswordBearer", []);
        }


        let urlPath = `/v2/user/flight_credits/{credit_id}`;
        urlPath = urlPath.replace(`{${"credit_id"}}`, encodeURIComponent(String(requestParameters['creditId'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete a manually-created flight credit
     */
    async v2UserFlightCreditsCreditIdDelete(requestParameters: V2UserFlightCreditsCreditIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.v2UserFlightCreditsCreditIdDeleteRaw(requestParameters, initOverrides);
    }

    /**
     * Update a manually-created flight credit
     */
    async v2UserFlightCreditsCreditIdPutRaw(requestParameters: V2UserFlightCreditsCreditIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FlightCredit>> {
        if (requestParameters['creditId'] == null) {
            throw new runtime.RequiredError(
                'creditId',
                'Required parameter "creditId" was null or undefined when calling v2UserFlightCreditsCreditIdPut().'
            );
        }

        if (requestParameters['updateFlightCreditRequest'] == null) {
            throw new runtime.RequiredError(
                'updateFlightCreditRequest',
                'Required parameter "updateFlightCreditRequest" was null or undefined when calling v2UserFlightCreditsCreditIdPut().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2PasswordBearer", []);
        }


        let urlPath = `/v2/user/flight_credits/{credit_id}`;
        urlPath = urlPath.replace(`{${"credit_id"}}`, encodeURIComponent(String(requestParameters['creditId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateFlightCreditRequestToJSON(requestParameters['updateFlightCreditRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FlightCreditFromJSON(jsonValue));
    }

    /**
     * Update a manually-created flight credit
     */
    async v2UserFlightCreditsCreditIdPut(requestParameters: V2UserFlightCreditsCreditIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FlightCredit> {
        const response = await this.v2UserFlightCreditsCreditIdPutRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get a user\'s active flight credits (active and partially redeemed)
     */
    async v2UserFlightCreditsGetRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FlightCreditsResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2PasswordBearer", []);
        }


        let urlPath = `/v2/user/flight_credits`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FlightCreditsResponseFromJSON(jsonValue));
    }

    /**
     * Get a user\'s active flight credits (active and partially redeemed)
     */
    async v2UserFlightCreditsGet(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FlightCreditsResponse> {
        const response = await this.v2UserFlightCreditsGetRaw(initOverrides);
        return await response.value();
    }

    /**
     * Manually add a flight credit
     */
    async v2UserFlightCreditsPostRaw(requestParameters: V2UserFlightCreditsPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FlightCredit>> {
        if (requestParameters['createFlightCreditRequest'] == null) {
            throw new runtime.RequiredError(
                'createFlightCreditRequest',
                'Required parameter "createFlightCreditRequest" was null or undefined when calling v2UserFlightCreditsPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2PasswordBearer", []);
        }


        let urlPath = `/v2/user/flight_credits`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateFlightCreditRequestToJSON(requestParameters['createFlightCreditRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FlightCreditFromJSON(jsonValue));
    }

    /**
     * Manually add a flight credit
     */
    async v2UserFlightCreditsPost(requestParameters: V2UserFlightCreditsPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FlightCredit> {
        const response = await this.v2UserFlightCreditsPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Delete a manually-created free-night credit
     */
    async v2UserFreeNightCreditsCreditIdDeleteRaw(requestParameters: V2UserFreeNightCreditsCreditIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['creditId'] == null) {
            throw new runtime.RequiredError(
                'creditId',
                'Required parameter "creditId" was null or undefined when calling v2UserFreeNightCreditsCreditIdDelete().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2PasswordBearer", []);
        }


        let urlPath = `/v2/user/free_night_credits/{credit_id}`;
        urlPath = urlPath.replace(`{${"credit_id"}}`, encodeURIComponent(String(requestParameters['creditId'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete a manually-created free-night credit
     */
    async v2UserFreeNightCreditsCreditIdDelete(requestParameters: V2UserFreeNightCreditsCreditIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.v2UserFreeNightCreditsCreditIdDeleteRaw(requestParameters, initOverrides);
    }

    /**
     * Update a manually-created free-night credit
     */
    async v2UserFreeNightCreditsCreditIdPutRaw(requestParameters: V2UserFreeNightCreditsCreditIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FreeNightCredit>> {
        if (requestParameters['creditId'] == null) {
            throw new runtime.RequiredError(
                'creditId',
                'Required parameter "creditId" was null or undefined when calling v2UserFreeNightCreditsCreditIdPut().'
            );
        }

        if (requestParameters['updateFreeNightCreditRequest'] == null) {
            throw new runtime.RequiredError(
                'updateFreeNightCreditRequest',
                'Required parameter "updateFreeNightCreditRequest" was null or undefined when calling v2UserFreeNightCreditsCreditIdPut().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2PasswordBearer", []);
        }


        let urlPath = `/v2/user/free_night_credits/{credit_id}`;
        urlPath = urlPath.replace(`{${"credit_id"}}`, encodeURIComponent(String(requestParameters['creditId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateFreeNightCreditRequestToJSON(requestParameters['updateFreeNightCreditRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FreeNightCreditFromJSON(jsonValue));
    }

    /**
     * Update a manually-created free-night credit
     */
    async v2UserFreeNightCreditsCreditIdPut(requestParameters: V2UserFreeNightCreditsCreditIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FreeNightCredit> {
        const response = await this.v2UserFreeNightCreditsCreditIdPutRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get a user\'s free-night credit inventory across loyalty programs
     */
    async v2UserFreeNightCreditsGetRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FreeNightCreditsResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2PasswordBearer", []);
        }


        let urlPath = `/v2/user/free_night_credits`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FreeNightCreditsResponseFromJSON(jsonValue));
    }

    /**
     * Get a user\'s free-night credit inventory across loyalty programs
     */
    async v2UserFreeNightCreditsGet(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FreeNightCreditsResponse> {
        const response = await this.v2UserFreeNightCreditsGetRaw(initOverrides);
        return await response.value();
    }

    /**
     * Manually add a free-night credit
     */
    async v2UserFreeNightCreditsPostRaw(requestParameters: V2UserFreeNightCreditsPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FreeNightCredit>> {
        if (requestParameters['createFreeNightCreditRequest'] == null) {
            throw new runtime.RequiredError(
                'createFreeNightCreditRequest',
                'Required parameter "createFreeNightCreditRequest" was null or undefined when calling v2UserFreeNightCreditsPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2PasswordBearer", []);
        }


        let urlPath = `/v2/user/free_night_credits`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateFreeNightCreditRequestToJSON(requestParameters['createFreeNightCreditRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FreeNightCreditFromJSON(jsonValue));
    }

    /**
     * Manually add a free-night credit
     */
    async v2UserFreeNightCreditsPost(requestParameters: V2UserFreeNightCreditsPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FreeNightCredit> {
        const response = await this.v2UserFreeNightCreditsPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Read a user\'s loyalty accounts
     */
    async v2UserLoyaltyAccountsGetRaw(requestParameters: V2UserLoyaltyAccountsGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<LoyaltyAccountsResponse>> {
        const queryParameters: any = {};

        if (requestParameters['extended'] != null) {
            queryParameters['extended'] = requestParameters['extended'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2PasswordBearer", []);
        }


        let urlPath = `/v2/user/loyalty_accounts`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => LoyaltyAccountsResponseFromJSON(jsonValue));
    }

    /**
     * Read a user\'s loyalty accounts
     */
    async v2UserLoyaltyAccountsGet(requestParameters: V2UserLoyaltyAccountsGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<LoyaltyAccountsResponse> {
        const response = await this.v2UserLoyaltyAccountsGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Delete loyalty account.
     */
    async v2UserLoyaltyAccountsLoyaltyAccountIdDeleteRaw(requestParameters: V2UserLoyaltyAccountsLoyaltyAccountIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['loyaltyAccountId'] == null) {
            throw new runtime.RequiredError(
                'loyaltyAccountId',
                'Required parameter "loyaltyAccountId" was null or undefined when calling v2UserLoyaltyAccountsLoyaltyAccountIdDelete().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2PasswordBearer", []);
        }


        let urlPath = `/v2/user/loyalty_accounts/{loyalty_account_id}`;
        urlPath = urlPath.replace(`{${"loyalty_account_id"}}`, encodeURIComponent(String(requestParameters['loyaltyAccountId'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete loyalty account.
     */
    async v2UserLoyaltyAccountsLoyaltyAccountIdDelete(requestParameters: V2UserLoyaltyAccountsLoyaltyAccountIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.v2UserLoyaltyAccountsLoyaltyAccountIdDeleteRaw(requestParameters, initOverrides);
    }

    /**
     * Update loyalty account.
     */
    async v2UserLoyaltyAccountsLoyaltyAccountIdPutRaw(requestParameters: V2UserLoyaltyAccountsLoyaltyAccountIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<LoyaltyAccount>> {
        if (requestParameters['loyaltyAccountId'] == null) {
            throw new runtime.RequiredError(
                'loyaltyAccountId',
                'Required parameter "loyaltyAccountId" was null or undefined when calling v2UserLoyaltyAccountsLoyaltyAccountIdPut().'
            );
        }

        if (requestParameters['createUpdateLoyaltyAccountRequest'] == null) {
            throw new runtime.RequiredError(
                'createUpdateLoyaltyAccountRequest',
                'Required parameter "createUpdateLoyaltyAccountRequest" was null or undefined when calling v2UserLoyaltyAccountsLoyaltyAccountIdPut().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2PasswordBearer", []);
        }


        let urlPath = `/v2/user/loyalty_accounts/{loyalty_account_id}`;
        urlPath = urlPath.replace(`{${"loyalty_account_id"}}`, encodeURIComponent(String(requestParameters['loyaltyAccountId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: CreateUpdateLoyaltyAccountRequestToJSON(requestParameters['createUpdateLoyaltyAccountRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => LoyaltyAccountFromJSON(jsonValue));
    }

    /**
     * Update loyalty account.
     */
    async v2UserLoyaltyAccountsLoyaltyAccountIdPut(requestParameters: V2UserLoyaltyAccountsLoyaltyAccountIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<LoyaltyAccount> {
        const response = await this.v2UserLoyaltyAccountsLoyaltyAccountIdPutRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create a loyalty account.
     */
    async v2UserLoyaltyAccountsPostRaw(requestParameters: V2UserLoyaltyAccountsPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<LoyaltyAccount>> {
        if (requestParameters['createUpdateLoyaltyAccountRequest'] == null) {
            throw new runtime.RequiredError(
                'createUpdateLoyaltyAccountRequest',
                'Required parameter "createUpdateLoyaltyAccountRequest" was null or undefined when calling v2UserLoyaltyAccountsPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2PasswordBearer", []);
        }


        let urlPath = `/v2/user/loyalty_accounts`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateUpdateLoyaltyAccountRequestToJSON(requestParameters['createUpdateLoyaltyAccountRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => LoyaltyAccountFromJSON(jsonValue));
    }

    /**
     * Create a loyalty account.
     */
    async v2UserLoyaltyAccountsPost(requestParameters: V2UserLoyaltyAccountsPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<LoyaltyAccount> {
        const response = await this.v2UserLoyaltyAccountsPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get a user\'s trips.
     */
    async v2UserTripsGetRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Itineraries>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2PasswordBearer", []);
        }


        let urlPath = `/v2/user/trips`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ItinerariesFromJSON(jsonValue));
    }

    /**
     * Get a user\'s trips.
     */
    async v2UserTripsGet(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Itineraries> {
        const response = await this.v2UserTripsGetRaw(initOverrides);
        return await response.value();
    }

    /**
     * Delete a manually-created suite upgrade certificate
     */
    async v2UserUpgradeCertificatesCertificateIdDeleteRaw(requestParameters: V2UserUpgradeCertificatesCertificateIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['certificateId'] == null) {
            throw new runtime.RequiredError(
                'certificateId',
                'Required parameter "certificateId" was null or undefined when calling v2UserUpgradeCertificatesCertificateIdDelete().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2PasswordBearer", []);
        }


        let urlPath = `/v2/user/upgrade_certificates/{certificate_id}`;
        urlPath = urlPath.replace(`{${"certificate_id"}}`, encodeURIComponent(String(requestParameters['certificateId'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete a manually-created suite upgrade certificate
     */
    async v2UserUpgradeCertificatesCertificateIdDelete(requestParameters: V2UserUpgradeCertificatesCertificateIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.v2UserUpgradeCertificatesCertificateIdDeleteRaw(requestParameters, initOverrides);
    }

    /**
     * Update a manually-created suite upgrade certificate
     */
    async v2UserUpgradeCertificatesCertificateIdPutRaw(requestParameters: V2UserUpgradeCertificatesCertificateIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UpgradeCertificate>> {
        if (requestParameters['certificateId'] == null) {
            throw new runtime.RequiredError(
                'certificateId',
                'Required parameter "certificateId" was null or undefined when calling v2UserUpgradeCertificatesCertificateIdPut().'
            );
        }

        if (requestParameters['updateUpgradeCertificateRequest'] == null) {
            throw new runtime.RequiredError(
                'updateUpgradeCertificateRequest',
                'Required parameter "updateUpgradeCertificateRequest" was null or undefined when calling v2UserUpgradeCertificatesCertificateIdPut().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2PasswordBearer", []);
        }


        let urlPath = `/v2/user/upgrade_certificates/{certificate_id}`;
        urlPath = urlPath.replace(`{${"certificate_id"}}`, encodeURIComponent(String(requestParameters['certificateId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateUpgradeCertificateRequestToJSON(requestParameters['updateUpgradeCertificateRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UpgradeCertificateFromJSON(jsonValue));
    }

    /**
     * Update a manually-created suite upgrade certificate
     */
    async v2UserUpgradeCertificatesCertificateIdPut(requestParameters: V2UserUpgradeCertificatesCertificateIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UpgradeCertificate> {
        const response = await this.v2UserUpgradeCertificatesCertificateIdPutRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get a user\'s suite upgrade certificate inventory across programs
     */
    async v2UserUpgradeCertificatesGetRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UpgradeCertificatesResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2PasswordBearer", []);
        }


        let urlPath = `/v2/user/upgrade_certificates`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UpgradeCertificatesResponseFromJSON(jsonValue));
    }

    /**
     * Get a user\'s suite upgrade certificate inventory across programs
     */
    async v2UserUpgradeCertificatesGet(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UpgradeCertificatesResponse> {
        const response = await this.v2UserUpgradeCertificatesGetRaw(initOverrides);
        return await response.value();
    }

    /**
     * Manually add a suite upgrade certificate
     */
    async v2UserUpgradeCertificatesPostRaw(requestParameters: V2UserUpgradeCertificatesPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UpgradeCertificate>> {
        if (requestParameters['createUpgradeCertificateRequest'] == null) {
            throw new runtime.RequiredError(
                'createUpgradeCertificateRequest',
                'Required parameter "createUpgradeCertificateRequest" was null or undefined when calling v2UserUpgradeCertificatesPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2PasswordBearer", []);
        }


        let urlPath = `/v2/user/upgrade_certificates`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateUpgradeCertificateRequestToJSON(requestParameters['createUpgradeCertificateRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UpgradeCertificateFromJSON(jsonValue));
    }

    /**
     * Manually add a suite upgrade certificate
     */
    async v2UserUpgradeCertificatesPost(requestParameters: V2UserUpgradeCertificatesPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UpgradeCertificate> {
        const response = await this.v2UserUpgradeCertificatesPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Return a user\'s past vehicle rental history (completed, non-cancelled). Used for recommendation scoring.
     */
    async v2UserVehiclesHistoryGetRaw(requestParameters: V2UserVehiclesHistoryGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<VehicleRentalHistoryResponse>> {
        const queryParameters: any = {};

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2PasswordBearer", []);
        }


        let urlPath = `/v2/user/vehicles/history`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => VehicleRentalHistoryResponseFromJSON(jsonValue));
    }

    /**
     * Return a user\'s past vehicle rental history (completed, non-cancelled). Used for recommendation scoring.
     */
    async v2UserVehiclesHistoryGet(requestParameters: V2UserVehiclesHistoryGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<VehicleRentalHistoryResponse> {
        const response = await this.v2UserVehiclesHistoryGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * A slimmed down version of /users/credits that only includes summary Gondola rewards information
     */
    async v2UsersCreditsGetRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UserCreditsSlim>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2PasswordBearer", []);
        }


        let urlPath = `/v2/users/credits`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UserCreditsSlimFromJSON(jsonValue));
    }

    /**
     * A slimmed down version of /users/credits that only includes summary Gondola rewards information
     */
    async v2UsersCreditsGet(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UserCreditsSlim> {
        const response = await this.v2UsersCreditsGetRaw(initOverrides);
        return await response.value();
    }

}
